(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.c0.be === region.dl.be)
	{
		return 'on line ' + region.c0.be;
	}
	return 'on lines ' + region.c0.be + ' through ' + region.dl.be;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.O,
		impl.cs,
		impl.R,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		dI: func(record.dI),
		ed: record.ed,
		dT: record.dT
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.dI;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.ed;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.dT) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.O,
		impl.cs,
		impl.R,
		function(sendToApp, initialModel) {
			var view = impl.cu;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.O,
		impl.cs,
		impl.R,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.cZ && impl.cZ(sendToApp)
			var view = impl.cu;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.ez);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.bB) && (_VirtualDom_doc.title = title = doc.bB);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.e1;
	var onUrlRequest = impl.e2;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		cZ: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.dY === next.dY
							&& curr.du === next.du
							&& curr.dR.a === next.dR.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		O: function(flags)
		{
			return A3(impl.O, flags, _Browser_getUrl(), key);
		},
		cu: impl.cu,
		cs: impl.cs,
		R: impl.R
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { eO: 'hidden', eB: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { eO: 'mozHidden', eB: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { eO: 'msHidden', eB: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { eO: 'webkitHidden', eB: 'webkitvisibilitychange' }
		: { eO: 'hidden', eB: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		d4: _Browser_getScene(),
		er: {
			ac: _Browser_window.pageXOffset,
			ad: _Browser_window.pageYOffset,
			et: _Browser_doc.documentElement.clientWidth,
			g: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		et: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		g: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			d4: {
				et: node.scrollWidth,
				g: node.scrollHeight
			},
			er: {
				ac: node.scrollLeft,
				ad: node.scrollTop,
				et: node.clientWidth,
				g: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			d4: _Browser_getScene(),
			er: {
				ac: x,
				ad: y,
				et: _Browser_doc.documentElement.clientWidth,
				g: _Browser_doc.documentElement.clientHeight
			},
			eG: {
				ac: x + rect.left,
				ad: y + rect.top,
				et: rect.width,
				g: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.e$) { flags += 'm'; }
	if (options.eA) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $author$project$Main$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$UrlRequest = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.j) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.l),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.l);
		} else {
			var treeLen = builder.j * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.m) : builder.m;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.j);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.l) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.l);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{m: nodeList, j: (len / $elm$core$Array$branchFactor) | 0, l: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {dr: fragment, du: host, dP: path, dR: port_, dY: protocol, dZ: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Main$LoadVocabulary = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Mdc = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$Domain$Questionnaire$Answers$empty = $elm$core$Dict$empty;
var $author$project$Domain$Questionnaire$CheckAnswerRules$empty = $elm$core$Dict$empty;
var $author$project$Domain$Questionnaire$Questions$empty = $elm$core$Array$empty;
var $author$project$Domain$Questionnaire$Paper$empty = {bI: $author$project$Domain$Questionnaire$CheckAnswerRules$empty, bO: '', eP: '', a9: false, cf: $author$project$Domain$Questionnaire$Questions$empty, cm: $author$project$Domain$Questionnaire$CheckAnswerRules$empty, cn: '', cq: '', bB: '', ct: ''};
var $author$project$Domain$defaultModel = {c7: $author$project$Domain$Questionnaire$Answers$empty, cc: $author$project$Domain$Questionnaire$Paper$empty};
var $author$project$Material$defaultModel = {c9: $elm$core$Dict$empty, db: $elm$core$Dict$empty, dc: $elm$core$Dict$empty, dh: $elm$core$Dict$empty, dk: $elm$core$Dict$empty, $7: $elm$core$Dict$empty, dv: $elm$core$Dict$empty, dG: $elm$core$Dict$empty, s: $elm$core$Dict$empty, d_: $elm$core$Dict$empty, _: $elm$core$Dict$empty, d7: $elm$core$Dict$empty, ea: $elm$core$Dict$empty, bx: $elm$core$Dict$empty, eg: $elm$core$Dict$empty, ei: $elm$core$Dict$empty, em: $elm$core$Dict$empty, en: $elm$core$Dict$empty};
var $author$project$Domain$Questionnaire$State$Answering$Init = 0;
var $author$project$Domain$Questionnaire$Question$Format$FreeText = {$: 4};
var $author$project$Domain$Questionnaire$Question$Format$empty = $author$project$Domain$Questionnaire$Question$Format$FreeText;
var $author$project$Domain$Questionnaire$Question$empty = {a3: $author$project$Domain$Questionnaire$Question$Format$empty, eP: '', a9: false, ba: false, bg: '', bB: ''};
var $author$project$Domain$Questionnaire$State$Answering$default = {c7: $author$project$Domain$Questionnaire$Answers$empty, z: 0, T: $author$project$Domain$Questionnaire$Question$empty, Z: 0, cf: $author$project$Domain$Questionnaire$Questions$empty, ay: 0, cm: $author$project$Domain$Questionnaire$CheckAnswerRules$empty};
var $author$project$Domain$Questionnaire$Range$empty = {b3: 0, b5: 0, cp: 0, bG: 0};
var $author$project$Selections$empty = $elm$core$Array$empty;
var $author$project$UI$Usecase$defaultState = {c6: $author$project$Domain$Questionnaire$State$Answering$default, eU: false, bu: $author$project$Domain$Questionnaire$Range$empty, d9: $author$project$Selections$empty, bv: ''};
var $author$project$Infra$Logger$Error = $elm$core$Basics$identity;
var $author$project$Infra$Logger$empty = '';
var $author$project$UI$Vocabulary$empty = {cB: '', cF: '', cI: '', eH: '', cK: '', cL: '', cN: '', cW: '', cX: '', cY: '', c1: ''};
var $author$project$UI$Page$ForAnswer = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Page$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Page$NotFound = function (a) {
	return {$: 2, a: a};
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {ar: frag, ax: params, ak: unvisited, bG: value, aA: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aA;
		var unvisited = _v0.ak;
		var params = _v0.ax;
		var frag = _v0.ar;
		var value = _v0.bG;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aA;
			var unvisited = _v1.ak;
			var params = _v1.ax;
			var frag = _v1.ar;
			var value = _v1.bG;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.ak;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.bG);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.bG);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.dP),
					$elm$url$Url$Parser$prepareQuery(url.dZ),
					url.dr,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.aA;
			var unvisited = _v0.ak;
			var params = _v0.ax;
			var frag = _v0.ar;
			var value = _v0.bG;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.dY;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.dr,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.dZ,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.dR,
					_Utils_ap(http, url.du)),
				url.dP)));
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$UI$Page$fromUrl = function (url) {
	var parser = $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				function (paperId) {
					return $author$project$UI$Page$Loading(
						$author$project$UI$Page$ForAnswer(paperId));
				},
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$top, $elm$url$Url$Parser$string))
			]));
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$UI$Page$NotFound(
			$elm$url$Url$toString(url)),
		A2($elm$url$Url$Parser$parse, parser, url));
};
var $author$project$UI$Page$getPaperId = function (page) {
	getPaperId:
	while (true) {
		switch (page.$) {
			case 0:
				var x = page.a;
				var $temp$page = x;
				page = $temp$page;
				continue getPaperId;
			case 1:
				var id = page.a;
				return $elm$core$Maybe$Just(id);
			default:
				return $elm$core$Maybe$Nothing;
		}
	}
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Material$init = function (_v0) {
	return $elm$core$Platform$Cmd$none;
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Port$loadPaper = _Platform_outgoingPort('loadPaper', $elm$json$Json$Encode$string);
var $author$project$Infra$Repository$Paper$load = function (paperId) {
	return $author$project$Port$loadPaper(paperId);
};
var $author$project$UI$Vocabulary$mock = {cB: 'このページを閉じる', cF: 'Copyright © Dream Motor School All Rights Reserved.', cI: '回答を入力する', eH: '404 Not Found', cK: '← もどる', cL: '次へ →', cN: '※必須回答', cW: 'お探しのページは一時的にアクセスができない状況にあるか、移動もしくは削除された可能性があります。', cX: 'ドリームモータースクール', cY: '回答を送信する', c1: '回答をはじめる'};
var $author$project$Infra$Repository$Vocabulary$load = function (msg) {
	return A2(
		$elm$core$Task$perform,
		msg,
		$elm$core$Task$succeed($author$project$UI$Vocabulary$mock));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Main$init = F3(
	function (_v0, url, key) {
		var page = $author$project$UI$Page$fromUrl(url);
		var defaultModel = {aq: $author$project$Domain$defaultModel, cJ: $author$project$Infra$Logger$empty, cP: key, b4: $author$project$Material$defaultModel, ai: page, co: $author$project$UI$Usecase$defaultState, al: url, bH: $author$project$UI$Vocabulary$empty};
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Material$init($author$project$Main$Mdc),
					$author$project$Infra$Repository$Vocabulary$load($author$project$Main$LoadVocabulary),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						$author$project$Infra$Repository$Paper$load,
						$author$project$UI$Page$getPaperId(page)))
				]));
		return _Utils_Tuple2(defaultModel, cmd);
	});
var $author$project$Main$Error = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$FailedLoadingPaper = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$LoadPaper = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Port$onFailedLoadingPaper = _Platform_incomingPort('onFailedLoadingPaper', $elm$json$Json$Decode$value);
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Infra$Logger$toError = $elm$core$Basics$identity;
var $author$project$Infra$Logger$withDecodeError = F3(
	function (error, ok, result) {
		if (!result.$) {
			var x = result.a;
			return ok(x);
		} else {
			var x = result.a;
			return error(
				$elm$json$Json$Decode$errorToString(x));
		}
	});
var $author$project$Infra$Repository$Paper$onFailedLoading = F2(
	function (error, failed) {
		return $author$project$Port$onFailedLoadingPaper(
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue(
					A2($elm$json$Json$Decode$map, $author$project$Infra$Logger$toError, $elm$json$Json$Decode$string)),
				A2($author$project$Infra$Logger$withDecodeError, error, failed)));
	});
var $author$project$Domain$Questionnaire$Paper$Paper = function (id) {
	return function (title) {
		return function (startGuide) {
			return function (confirmationMessage) {
				return function (thankYouMessage) {
					return function (questions) {
						return function (skipRules) {
							return function (alertRules) {
								return function (isEnabled) {
									return function (updateTime) {
										return {bI: alertRules, bO: confirmationMessage, eP: id, a9: isEnabled, cf: questions, cm: skipRules, cn: startGuide, cq: thankYouMessage, bB: title, ct: updateTime};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Domain$Questionnaire$CheckAnswerRule$CheckAnswerRule = F5(
	function (id, name, operation, checkTarget, operationTargets) {
		return {aZ: checkTarget, eP: id, b6: name, aL: operation, aM: operationTargets};
	});
var $author$project$Domain$Questionnaire$CheckAnswerOperation$And = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Questionnaire$CheckAnswerOperation$None = {$: 0};
var $author$project$Domain$Questionnaire$CheckAnswerOperation$Not = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Questionnaire$CheckAnswerOperation$Or = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Questionnaire$CheckAnswerOperation$WhenSelected = function (a) {
	return {$: 4, a: a};
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $author$project$Json$CustomType$CustomType = F2(
	function (kind, value) {
		return {eW: kind, bG: value};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Json$CustomType$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'kind',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Json$CustomType$CustomType)));
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$list = _Json_decodeList;
function $author$project$Domain$Questionnaire$CheckAnswerOperation$cyclic$decoder() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (x) {
			return A2(
				$elm$json$Json$Decode$field,
				'value',
				function () {
					var _v0 = x.eW;
					switch (_v0) {
						case 'None':
							return $elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$CheckAnswerOperation$None);
						case 'And':
							return A2(
								$elm$json$Json$Decode$map,
								$author$project$Domain$Questionnaire$CheckAnswerOperation$And,
								$elm$json$Json$Decode$list(
									$author$project$Domain$Questionnaire$CheckAnswerOperation$cyclic$decoder()));
						case 'Or':
							return A2(
								$elm$json$Json$Decode$map,
								$author$project$Domain$Questionnaire$CheckAnswerOperation$Or,
								$elm$json$Json$Decode$list(
									$author$project$Domain$Questionnaire$CheckAnswerOperation$cyclic$decoder()));
						case 'Not':
							return A2(
								$elm$json$Json$Decode$map,
								$author$project$Domain$Questionnaire$CheckAnswerOperation$Not,
								$author$project$Domain$Questionnaire$CheckAnswerOperation$cyclic$decoder());
						case 'WhenSelected':
							return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$CheckAnswerOperation$WhenSelected, $elm$json$Json$Decode$string);
						default:
							return $elm$json$Json$Decode$fail('Undefined kind of CheckAnswerOperation.');
					}
				}());
		},
		$author$project$Json$CustomType$decoder);
}
var $author$project$Domain$Questionnaire$CheckAnswerOperation$decoder = $author$project$Domain$Questionnaire$CheckAnswerOperation$cyclic$decoder();
$author$project$Domain$Questionnaire$CheckAnswerOperation$cyclic$decoder = function () {
	return $author$project$Domain$Questionnaire$CheckAnswerOperation$decoder;
};
var $author$project$Domain$Questionnaire$CheckAnswerRule$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'operationTargets',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'checkTarget',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'operation',
			$author$project$Domain$Questionnaire$CheckAnswerOperation$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$CheckAnswerRule$CheckAnswerRule))))));
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Domain$Questionnaire$CheckAnswerRules$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (rule) {
			return _Utils_Tuple2(rule.eP, rule);
		}),
	$elm$core$Dict$fromList);
var $author$project$Domain$Questionnaire$CheckAnswerRules$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Domain$Questionnaire$CheckAnswerRules$fromList,
	$elm$json$Json$Decode$list($author$project$Domain$Questionnaire$CheckAnswerRule$decoder));
var $elm$json$Json$Decode$array = _Json_decodeArray;
var $author$project$Domain$Questionnaire$Question$Question = F6(
	function (id, title, note, format, isRequired, isEnabled) {
		return {a3: format, eP: id, a9: isEnabled, ba: isRequired, bg: note, bB: title};
	});
var $author$project$Domain$Questionnaire$Question$Format$Multiple = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Questionnaire$Question$Format$Range = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Questionnaire$Question$Format$Singular = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Questionnaire$Question$Format$ValidatedText = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Questionnaire$Range$Range = F4(
	function (min, max, value, step) {
		return {b3: max, b5: min, cp: step, bG: value};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Domain$Questionnaire$Range$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'step',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'min',
				$elm$json$Json$Decode$float,
				$elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$Range$Range)))));
var $author$project$Domain$Questionnaire$SelectionSet$SelectionSet = F3(
	function (id, title, selections) {
		return {eP: id, aR: selections, bB: title};
	});
var $author$project$Selection$Selection = F3(
	function (id, title, isSelected) {
		return {eP: id, b$: isSelected, bB: title};
	});
var $author$project$Selection$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isSelected',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Selection$Selection))));
var $author$project$Selections$decoder = $elm$json$Json$Decode$array($author$project$Selection$decoder);
var $author$project$Domain$Questionnaire$SelectionSet$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'selections',
	$author$project$Selections$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$SelectionSet$SelectionSet))));
var $author$project$Domain$Questionnaire$Validation$Validation = F3(
	function (id, title, rules) {
		return {eP: id, cj: rules, bB: title};
	});
var $author$project$Domain$Questionnaire$Validation$Rules$None = {$: 2};
var $author$project$Domain$Questionnaire$Validation$Rules$Numeric = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Questionnaire$Validation$Rules$Text = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Questionnaire$Validation$NumericRule$ValidDecimalPartLength = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Questionnaire$Validation$NumericRule$ValidIntegerPartLength = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Questionnaire$Validation$NumericRule$ValidNumericRange = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Questionnaire$Validation$NumericRule$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$json$Json$Decode$field,
			'value',
			function () {
				var _v0 = x.eW;
				switch (_v0) {
					case 'ValidIntegerPartLength':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Validation$NumericRule$ValidIntegerPartLength, $author$project$Domain$Questionnaire$Range$decoder);
					case 'ValidDecimalPartLength':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Validation$NumericRule$ValidDecimalPartLength, $author$project$Domain$Questionnaire$Range$decoder);
					case 'ValidNumericRange':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Validation$NumericRule$ValidNumericRange, $author$project$Domain$Questionnaire$Range$decoder);
					default:
						return $elm$json$Json$Decode$fail('Undefined kind of rule.');
				}
			}());
	},
	$author$project$Json$CustomType$decoder);
var $author$project$Domain$Questionnaire$Validation$NumericRules$decoder = $elm$json$Json$Decode$array($author$project$Domain$Questionnaire$Validation$NumericRule$decoder);
var $author$project$Domain$Questionnaire$Validation$TextRule$ValidCharacters = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Questionnaire$Validation$TextRule$ValidLength = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Questionnaire$Validation$TextRule$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$json$Json$Decode$field,
			'value',
			function () {
				var _v0 = x.eW;
				switch (_v0) {
					case 'ValidCharacters':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Validation$TextRule$ValidCharacters, $elm$json$Json$Decode$string);
					case 'ValidLength':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Validation$TextRule$ValidLength, $author$project$Domain$Questionnaire$Range$decoder);
					default:
						return $elm$json$Json$Decode$fail('Undefined kind of rule.');
				}
			}());
	},
	$author$project$Json$CustomType$decoder);
var $author$project$Domain$Questionnaire$Validation$TextRules$decoder = $elm$json$Json$Decode$array($author$project$Domain$Questionnaire$Validation$TextRule$decoder);
var $author$project$Domain$Questionnaire$Validation$Rules$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$json$Json$Decode$field,
			'value',
			function () {
				var _v0 = x.eW;
				switch (_v0) {
					case 'Text':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Validation$Rules$Text, $author$project$Domain$Questionnaire$Validation$TextRules$decoder);
					case 'Numeric':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Validation$Rules$Numeric, $author$project$Domain$Questionnaire$Validation$NumericRules$decoder);
					case 'None':
						return $elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$Validation$Rules$None);
					default:
						return $elm$json$Json$Decode$fail('Undefined kind of rules.');
				}
			}());
	},
	$author$project$Json$CustomType$decoder);
var $author$project$Domain$Questionnaire$Validation$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rules',
	$author$project$Domain$Questionnaire$Validation$Rules$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$Validation$Validation))));
var $author$project$Domain$Questionnaire$Question$Format$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$json$Json$Decode$field,
			'value',
			function () {
				var _v0 = x.eW;
				switch (_v0) {
					case 'Multiple':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Question$Format$Multiple, $author$project$Domain$Questionnaire$SelectionSet$decoder);
					case 'Singular':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Question$Format$Singular, $author$project$Domain$Questionnaire$SelectionSet$decoder);
					case 'Range':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Question$Format$Range, $author$project$Domain$Questionnaire$Range$decoder);
					case 'ValidatedText':
						return A2($elm$json$Json$Decode$map, $author$project$Domain$Questionnaire$Question$Format$ValidatedText, $author$project$Domain$Questionnaire$Validation$decoder);
					case 'FreeText':
						return $elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$Question$Format$FreeText);
					default:
						return $elm$json$Json$Decode$fail('Undefined kind of Format.');
				}
			}());
	},
	$author$project$Json$CustomType$decoder);
var $author$project$Domain$Questionnaire$Question$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isEnabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isRequired',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'format',
			$author$project$Domain$Questionnaire$Question$Format$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'note',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$Question$Question)))))));
var $author$project$Domain$Questionnaire$Questions$decoder = $elm$json$Json$Decode$array($author$project$Domain$Questionnaire$Question$decoder);
var $author$project$Domain$Questionnaire$Paper$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'updateTime',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isEnabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'alertRules',
			$author$project$Domain$Questionnaire$CheckAnswerRules$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'skipRules',
				$author$project$Domain$Questionnaire$CheckAnswerRules$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'questions',
					$author$project$Domain$Questionnaire$Questions$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'thankYouMessage',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'confirmationMessage',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'startGuide',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Domain$Questionnaire$Paper$Paper)))))))))));
var $author$project$Port$onLoadPaper = _Platform_incomingPort('onLoadPaper', $elm$json$Json$Decode$value);
var $author$project$Infra$Repository$Paper$onLoad = F2(
	function (error, ok) {
		return $author$project$Port$onLoadPaper(
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue($author$project$Domain$Questionnaire$Paper$decoder),
				A2($author$project$Infra$Logger$withDecodeError, error, ok)));
	});
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$Infra$Repository$Paper$onLoad, $author$project$Main$Error, $author$project$Main$LoadPaper),
				A2($author$project$Infra$Repository$Paper$onFailedLoading, $author$project$Main$Error, $author$project$Main$FailedLoadingPaper)
			]));
};
var $author$project$UI$Page$finishLoading = function (page) {
	if (!page.$) {
		var x = page.a;
		return x;
	} else {
		return page;
	}
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$UI$Page$notFound = A2($elm$core$Basics$composeR, $elm$url$Url$toString, $author$project$UI$Page$NotFound);
var $arturopala$elm_monocle$Monocle$Lens$Lens = F2(
	function (get, set) {
		return {a5: get, cl: set};
	});
var $author$project$Domain$paper = A2(
	$arturopala$elm_monocle$Monocle$Lens$Lens,
	function ($) {
		return $.cc;
	},
	F2(
		function (b, a) {
			return _Utils_update(
				a,
				{cc: b});
		}));
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Port$error = _Platform_outgoingPort('error', $elm$json$Json$Encode$string);
var $author$project$Infra$Logger$send = $author$project$Port$error;
var $author$project$Infra$Logger$sendError = function (_v0) {
	var err = _v0;
	return $author$project$Infra$Logger$send(err);
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Internal$Dispatch$forward = function (msgs) {
	return $elm$core$Platform$Cmd$batch(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Task$perform($elm$core$Basics$identity),
				$elm$core$Task$succeed),
			msgs));
};
var $author$project$Internal$Msg$ButtonMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Idle = {$: 0};
var $author$project$Internal$Ripple$Model$defaultModel = {aD: 0, v: $author$project$Internal$Ripple$Model$Idle, cA: $elm$core$Maybe$Nothing, bY: false};
var $author$project$Internal$Button$Model$defaultModel = {_: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Component$indexed = F3(
	function (get_model, set_model, model0) {
		var set_ = F3(
			function (idx, store, model) {
				return A2(
					set_model,
					A3(
						$elm$core$Dict$insert,
						idx,
						model,
						get_model(store)),
					store);
			});
		var get_ = F2(
			function (idx, store) {
				return A2(
					$elm$core$Maybe$withDefault,
					model0,
					A2(
						$elm$core$Dict$get,
						idx,
						get_model(store)));
			});
		return {a5: get_, cl: set_};
	});
var $author$project$Internal$Button$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.c9;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{c9: x});
		}),
	$author$project$Internal$Button$Model$defaultModel);
var $author$project$Internal$Component$react = F8(
	function (get, set, ctor, update, lift, msg, idx, store) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$map(
				A2(set, idx, store)),
			A3(
				update,
				A2(
					$elm$core$Basics$composeL,
					lift,
					ctor(idx)),
				msg,
				A2(get, idx, store)));
	});
var $author$project$Internal$Button$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Internal$Helpers$delayedCmd = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Internal$Ripple$Model$Activate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Activated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Ripple$Model$ActivationEnded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Internal$Ripple$Model$Deactivated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Ripple$Model$DeactivationEnded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Ripple$Model$Reactivate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Internal$Ripple$Implementation$normalizedEventCoords = F3(
	function (event, pageOffset, clientRect) {
		var _v0 = pageOffset;
		var x = _v0.ac;
		var y = _v0.ad;
		var documentX = x + clientRect.ac;
		var documentY = x + clientRect.ad;
		var _v1 = event.e4;
		var pageX = _v1.dM;
		var pageY = _v1.dN;
		return {ac: pageX - documentX, ad: pageY - documentY};
	});
var $author$project$Internal$Ripple$Implementation$fgTranslationCoords = F2(
	function (isUnbounded, _v0) {
		var frame = _v0.V;
		var activationEvent = _v0.am;
		var windowPageOffset = _v0.eu;
		var wasActivatedByPointer = _v0.es;
		var maxDimension = A2($elm$core$Basics$max, frame.et, frame.g);
		var initialSize = maxDimension * 0.6;
		var startPoint = function () {
			var _v1 = A3($author$project$Internal$Ripple$Implementation$normalizedEventCoords, activationEvent, windowPageOffset, frame);
			var x = _v1.ac;
			var y = _v1.ad;
			return {ac: x - (initialSize / 2), ad: y - (initialSize / 2)};
		}();
		var endPoint = {ac: (frame.et - initialSize) / 2, ad: (frame.g - initialSize) / 2};
		return {dm: endPoint, ec: startPoint};
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Internal$Ripple$Implementation$animateActivation = F4(
	function (isUnbounded, frame, windowPageOffset, activationEvent) {
		var wasActivatedByPointer = true;
		var _v0 = A2(
			$author$project$Internal$Ripple$Implementation$fgTranslationCoords,
			isUnbounded,
			{am: activationEvent, V: frame, es: wasActivatedByPointer, eu: windowPageOffset});
		var startPoint = _v0.ec;
		var endPoint = _v0.dm;
		var translateEnd = isUnbounded ? '' : ($elm$core$String$fromFloat(endPoint.ac) + ('px, ' + ($elm$core$String$fromFloat(endPoint.ad) + 'px')));
		var translateStart = isUnbounded ? '' : ($elm$core$String$fromFloat(startPoint.ac) + ('px, ' + ($elm$core$String$fromFloat(startPoint.ad) + 'px')));
		return {aa: translateEnd, ab: translateStart};
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Internal$Ripple$Model$numbers = {eF: 225, eN: 150, eR: 0.6, e3: 10, ek: 300};
var $elm$core$Basics$pow = _Basics_pow;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $author$project$Internal$Ripple$Implementation$layoutInternal = F2(
	function (isUnbounded, frame) {
		var maxDim = A2($elm$core$Basics$max, frame.et, frame.g);
		var initialSize = $elm$core$Basics$floor(maxDim * $author$project$Internal$Ripple$Model$numbers.eR);
		var hypotenuse = $elm$core$Basics$sqrt(
			A2($elm$core$Basics$pow, frame.et, 2) + A2($elm$core$Basics$pow, frame.g, 2));
		var boundedRadius = hypotenuse + $author$project$Internal$Ripple$Model$numbers.e3;
		var maxRadius = isUnbounded ? maxDim : boundedRadius;
		var fgScale = maxRadius / initialSize;
		return {N: fgScale, P: initialSize};
	});
var $author$project$Internal$Ripple$Implementation$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.v);
		_v0$13:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bY: true}),
						$elm$core$Platform$Cmd$none);
				case 1:
					var _v2 = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bY: false}),
						$elm$core$Platform$Cmd$none);
				case 8:
					var _v3 = _v0.a;
					var isUnbounded = _v3.a;
					var clientRect = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cA: $elm$core$Maybe$Just(clientRect)
							}),
						$elm$core$Platform$Cmd$none);
				case 2:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var domId = _v4.a;
						var activateData = _v4.b;
						var _v5 = _v0.b;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Internal$Ripple$Model$Activate(activateData),
								$elm$browser$Browser$Dom$getElement(domId)));
					} else {
						var _v6 = _v0.a;
						var domId = _v6.a;
						var activateData = _v6.b;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Internal$Ripple$Model$Reactivate(activateData),
								$elm$browser$Browser$Dom$getElement(domId)));
					}
				case 4:
					switch (_v0.b.$) {
						case 1:
							var _v7 = _v0.a;
							var activateData = _v7.a;
							var element = _v7.b;
							var activationEvent = _v0.b.a.am;
							return _Utils_eq(activateData.a1.a2, activationEvent.a2) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{v: $author$project$Internal$Ripple$Model$Idle}),
								A2(
									$elm$core$Task$perform,
									function (_v8) {
										return A2($author$project$Internal$Ripple$Model$Activate, activateData, element);
									},
									$elm$core$Task$succeed(0))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							var _v9 = _v0.a;
							var activateData = _v9.a;
							var element = _v9.b;
							var activationEvent = _v0.b.a.am;
							return _Utils_eq(activateData.a1.a2, activationEvent.a2) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{v: $author$project$Internal$Ripple$Model$Idle}),
								A2(
									$elm$core$Task$perform,
									function (_v10) {
										return A2($author$project$Internal$Ripple$Model$Activate, activateData, element);
									},
									$elm$core$Task$succeed(0))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						default:
							var _v11 = _v0.a;
							var activateData = _v11.a;
							var element = _v11.b;
							var _v12 = _v0.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{v: $author$project$Internal$Ripple$Model$Idle}),
								A2(
									$elm$core$Task$perform,
									function (_v13) {
										return A2($author$project$Internal$Ripple$Model$Activate, activateData, element);
									},
									$elm$core$Task$succeed(0)));
					}
				case 3:
					if (_v0.a.b.$ === 1) {
						var _v14 = _v0.a;
						var activateData = _v14.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var _v15 = _v0.a;
						var activateData = _v15.a;
						var element = _v15.b.a.eG;
						var viewport = _v15.b.a.er;
						var newAnimationCounter = model.aD + 1;
						var _v16 = A4($author$project$Internal$Ripple$Implementation$animateActivation, activateData.bb, element, viewport, activateData.a1);
						var translateStart = _v16.ab;
						var translateEnd = _v16.aa;
						var _v17 = A2($author$project$Internal$Ripple$Implementation$layoutInternal, activateData.bb, element);
						var fgScale = _v17.N;
						var initialSize = _v17.P;
						var activatedData = {
							am: activateData.a1,
							cx: false,
							bQ: false,
							N: fgScale,
							V: {g: element.g, p: element.ac, i: element.ad, et: element.et},
							P: initialSize,
							aa: translateEnd,
							ab: translateStart,
							c4: activateData.c4
						};
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aD: newAnimationCounter,
									v: $author$project$Internal$Ripple$Model$Activated(activatedData)
								}),
							A2(
								$elm$core$Task$perform,
								function (_v18) {
									return $author$project$Internal$Ripple$Model$ActivationEnded(newAnimationCounter);
								},
								$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.eF)));
					}
				case 5:
					if (_v0.b.$ === 1) {
						var animationCount = _v0.a.a;
						var activatedData = _v0.b.a;
						if (_Utils_eq(animationCount, model.aD)) {
							if (activatedData.bQ) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											v: $author$project$Internal$Ripple$Model$Deactivated(activatedData)
										}),
									A2(
										$elm$core$Task$perform,
										function (_v19) {
											return $author$project$Internal$Ripple$Model$DeactivationEnded(model.aD);
										},
										$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.ek)));
							} else {
								var newActivatedData = _Utils_update(
									activatedData,
									{cx: true});
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											v: $author$project$Internal$Ripple$Model$Activated(newActivatedData)
										}),
									$elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$13;
					}
				case 6:
					if (_v0.b.$ === 1) {
						var _v20 = _v0.a;
						var activatedData = _v0.b.a;
						if (activatedData.cx) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										v: $author$project$Internal$Ripple$Model$Deactivated(activatedData)
									}),
								A2(
									$elm$core$Task$perform,
									function (_v21) {
										return $author$project$Internal$Ripple$Model$DeactivationEnded(model.aD);
									},
									$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.ek)));
						} else {
							var newActivatedData = _Utils_update(
								activatedData,
								{bQ: true});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										v: $author$project$Internal$Ripple$Model$Activated(newActivatedData)
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$13;
					}
				default:
					if (_v0.b.$ === 2) {
						var animationCount = _v0.a.a;
						return _Utils_eq(animationCount, model.aD) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{v: $author$project$Internal$Ripple$Model$Idle}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$13;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Internal$Button$Implementation$update = F3(
	function (lift, msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model._);
			var rippleState = _v1.a;
			var rippleCmd = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					_Utils_update(
						model,
						{_: rippleState})),
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, lift, $author$project$Internal$Button$Model$RippleMsg),
					rippleCmd));
		} else {
			var doRipple = msg.a;
			var msg_ = msg.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				A2(
					$author$project$Internal$Helpers$delayedCmd,
					doRipple ? 150 : 0,
					msg_));
		}
	});
var $author$project$Internal$Button$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Button$Implementation$getSet.a5, $author$project$Internal$Button$Implementation$getSet.cl, $author$project$Internal$Msg$ButtonMsg, $author$project$Internal$Button$Implementation$update);
var $author$project$Internal$Msg$CheckboxMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Internal$Checkbox$Model$defaultModel = {bJ: $elm$core$Maybe$Nothing, eT: false, b1: $elm$core$Maybe$Nothing};
var $author$project$Internal$Checkbox$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.db;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{db: x});
		}),
	$author$project$Internal$Checkbox$Model$defaultModel);
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Internal$Checkbox$Model$CheckedIndeterminate = 3;
var $author$project$Internal$Checkbox$Model$CheckedUnchecked = 2;
var $author$project$Internal$Checkbox$Model$IndeterminateChecked = 4;
var $author$project$Internal$Checkbox$Model$IndeterminateUnchecked = 5;
var $author$project$Internal$Checkbox$Model$UncheckedChecked = 0;
var $author$project$Internal$Checkbox$Model$UncheckedIndeterminate = 1;
var $author$project$Internal$Checkbox$Implementation$animationState = F2(
	function (oldState, state) {
		var _v0 = _Utils_Tuple2(oldState, state);
		_v0$6:
		while (true) {
			if (_v0.a.$ === 1) {
				if (!_v0.b.$) {
					if (!_v0.b.a) {
						var _v5 = _v0.a;
						var _v6 = _v0.b.a;
						return $elm$core$Maybe$Just(4);
					} else {
						var _v7 = _v0.a;
						var _v8 = _v0.b.a;
						return $elm$core$Maybe$Just(5);
					}
				} else {
					break _v0$6;
				}
			} else {
				if (_v0.a.a === 1) {
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a.a;
						var _v2 = _v0.b;
						return $elm$core$Maybe$Just(1);
					} else {
						if (!_v0.b.a) {
							var _v9 = _v0.a.a;
							var _v10 = _v0.b.a;
							return $elm$core$Maybe$Just(0);
						} else {
							break _v0$6;
						}
					}
				} else {
					if (_v0.b.$ === 1) {
						var _v3 = _v0.a.a;
						var _v4 = _v0.b;
						return $elm$core$Maybe$Just(3);
					} else {
						if (_v0.b.a === 1) {
							var _v11 = _v0.a.a;
							var _v12 = _v0.b.a;
							return $elm$core$Maybe$Just(2);
						} else {
							break _v0$6;
						}
					}
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Internal$Checkbox$Implementation$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 2:
				var focus = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{eT: focus})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var lastKnownState = msg.a;
				var state = msg.b;
				var animation = A2(
					$elm$core$Maybe$andThen,
					function (lastKnownState_) {
						return A2($author$project$Internal$Checkbox$Implementation$animationState, lastKnownState_, state);
					},
					lastKnownState);
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bJ: animation,
								b1: $elm$core$Maybe$Just(state)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bJ: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Checkbox$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Checkbox$Implementation$getSet.a5, $author$project$Internal$Checkbox$Implementation$getSet.cl, $author$project$Internal$Msg$CheckboxMsg, $author$project$Internal$Checkbox$Implementation$update);
var $author$project$Internal$Msg$ChipMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Internal$Chip$Model$defaultModel = {_: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Chip$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dc;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dc: x});
		}),
	$author$project$Internal$Chip$Model$defaultModel);
var $author$project$Internal$Chip$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Chip$Implementation$update = F3(
	function (lift, msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model._);
			var ripple = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					_Utils_update(
						model,
						{_: ripple})),
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, lift, $author$project$Internal$Chip$Model$RippleMsg),
					cmd));
		} else {
			var msg_ = msg.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				A2($author$project$Internal$Helpers$delayedCmd, 150, msg_));
		}
	});
var $author$project$Internal$Chip$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Chip$Implementation$getSet.a5, $author$project$Internal$Chip$Implementation$getSet.cl, $author$project$Internal$Msg$ChipMsg, $author$project$Internal$Chip$Implementation$update);
var $author$project$Internal$Msg$DialogMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Internal$Dialog$Model$defaultModel = {aY: false, o: false};
var $author$project$Internal$Dialog$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dh;
	},
	F2(
		function (x, c) {
			return _Utils_update(
				c,
				{dh: x});
		}),
	$author$project$Internal$Dialog$Model$defaultModel);
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Internal$Dialog$Implementation$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 1:
				var isOpen = msg.a;
				return (!_Utils_eq(isOpen, model.o)) ? _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{aY: true, o: isOpen})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{aY: false})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Dialog$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Dialog$Implementation$getSet.a5, $author$project$Internal$Dialog$Implementation$getSet.cl, $author$project$Internal$Msg$DialogMsg, $author$project$Internal$Dialog$Implementation$update);
var $author$project$Internal$Msg$DrawerMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Internal$Drawer$Model$defaultModel = {aY: false, bM: false, o: false};
var $author$project$Internal$Drawer$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dk;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dk: x});
		}),
	$author$project$Internal$Drawer$Model$defaultModel);
var $elm$core$Basics$not = _Basics_not;
var $author$project$Internal$Drawer$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 1:
				var isOpen = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{aY: true, bM: !isOpen, o: true})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								aY: false,
								bM: false,
								o: model.bM ? false : model.o
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Drawer$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Drawer$Implementation$getSet.a5, $author$project$Internal$Drawer$Implementation$getSet.cl, $author$project$Internal$Msg$DrawerMsg, $author$project$Internal$Drawer$Implementation$update);
var $author$project$Internal$Msg$FabMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Internal$Component$generalise = F4(
	function (update, lift, msg, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A2(update, msg, model)));
	});
var $author$project$Internal$Fab$Model$defaultModel = {_: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Fab$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.$7;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{$7: x});
		}),
	$author$project$Internal$Fab$Model$defaultModel);
var $author$project$Internal$Fab$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Fab$Implementation$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model._);
			var rippleState = _v1.a;
			var rippleCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{_: rippleState}),
				A2($elm$core$Platform$Cmd$map, $author$project$Internal$Fab$Model$RippleMsg, rippleCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Fab$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Fab$Implementation$getSet.a5,
	$author$project$Internal$Fab$Implementation$getSet.cl,
	$author$project$Internal$Msg$FabMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Fab$Implementation$update));
var $author$project$Internal$Msg$IconButtonMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Internal$IconButton$Model$defaultModel = {k: false, _: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$IconButton$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dv;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dv: x});
		}),
	$author$project$Internal$IconButton$Model$defaultModel);
var $author$project$Internal$IconButton$Model$RippleMsg = $elm$core$Basics$identity;
var $author$project$Internal$IconButton$Implementation$update = F2(
	function (msg, model) {
		var msg_ = msg;
		var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model._);
		var ripple = _v1.a;
		var effects = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{_: ripple}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, effects));
	});
var $author$project$Internal$IconButton$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$IconButton$Implementation$getSet.a5,
	$author$project$Internal$IconButton$Implementation$getSet.cl,
	$author$project$Internal$Msg$IconButtonMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$IconButton$Implementation$update));
var $author$project$Internal$Msg$ListMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Internal$List$Model$defaultModel = {bY: $elm$core$Maybe$Nothing, bq: $elm$core$Dict$empty};
var $author$project$Internal$List$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dG;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dG: x});
		}),
	$author$project$Internal$List$Model$defaultModel);
var $author$project$Internal$List$Model$NoOp = {$: 0};
var $author$project$Internal$List$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Internal$List$Implementation$send = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Internal$List$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 1:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.bq)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bq: A3($elm$core$Dict$insert, index, ripple, model.bq)
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							lift,
							$author$project$Internal$List$Model$RippleMsg(index)),
						effects));
			case 3:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bY: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 2:
				var id = msg.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bY: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return lift($author$project$Internal$List$Model$NoOp);
						},
						$elm$browser$Browser$Dom$focus(id)));
			case 4:
				var index = msg.a;
				var m = msg.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bY: $elm$core$Maybe$Nothing})),
					$author$project$Internal$List$Implementation$send(
						m(index)));
			default:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$List$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$List$Implementation$getSet.a5, $author$project$Internal$List$Implementation$getSet.cl, $author$project$Internal$Msg$ListMsg, $author$project$Internal$List$Implementation$update);
var $author$project$Internal$Msg$MenuMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Internal$Menu$Model$defaultModel = {aY: false, as: $elm$core$Maybe$Nothing, at: $elm$core$Maybe$Nothing, cQ: false, dG: $author$project$Internal$List$Model$defaultModel, o: false, I: $elm$core$Maybe$Nothing};
var $author$project$Internal$Menu$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.s;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{s: x});
		}),
	$author$project$Internal$Menu$Model$defaultModel);
var $author$project$Internal$Menu$Model$AnimationEnd = {$: 2};
var $author$project$Internal$Menu$Model$Close = {$: 4};
var $author$project$Internal$Menu$Model$ListMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Internal$Menu$Model$NoOp = {$: 0};
var $author$project$Internal$Menu$Model$Open = {$: 3};
var $author$project$Internal$Menu$Implementation$update = F3(
	function (lift, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 5:
					var $temp$lift = lift,
						$temp$msg = model.o ? $author$project$Internal$Menu$Model$Close : $author$project$Internal$Menu$Model$Open,
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 3:
					return (!model.o) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{aY: true, as: $elm$core$Maybe$Nothing, o: true})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 4:
					return model.o ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{aY: true, o: false})),
						A2($elm$core$Maybe$withDefault, false, model.I) ? A2(
							$author$project$Internal$Helpers$delayedCmd,
							70,
							lift($author$project$Internal$Menu$Model$AnimationEnd)) : A2(
							$author$project$Internal$Helpers$delayedCmd,
							0,
							lift($author$project$Internal$Menu$Model$AnimationEnd))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 6:
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2(
							$author$project$Internal$Helpers$delayedCmd,
							50,
							lift($author$project$Internal$Menu$Model$Close)));
				case 1:
					var config = msg.a;
					var geometry = msg.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									as: $elm$core$Maybe$Just(geometry),
									I: $elm$core$Maybe$Just(config.I)
								})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									function (_v1) {
										return lift($author$project$Internal$Menu$Model$NoOp);
									},
									$elm$browser$Browser$Dom$focus(config.dq)),
									config.I ? A2(
									$author$project$Internal$Helpers$delayedCmd,
									120,
									lift($author$project$Internal$Menu$Model$AnimationEnd)) : A2(
									$author$project$Internal$Helpers$delayedCmd,
									0,
									lift($author$project$Internal$Menu$Model$AnimationEnd))
								])));
				case 2:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{aY: false})),
						$elm$core$Platform$Cmd$none);
				case 7:
					if (model.o && (!_Utils_eq(model.as, $elm$core$Maybe$Nothing))) {
						var $temp$lift = lift,
							$temp$msg = $author$project$Internal$Menu$Model$Close,
							$temp$model = model;
						lift = $temp$lift;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				case 8:
					var shiftKey = msg.a.c_;
					var altKey = msg.a.cy;
					var ctrlKey = msg.a.cG;
					var metaKey = msg.a.cS;
					var key = msg.b;
					var keyCode = msg.c;
					var isSpace = (key === 'Space') || (keyCode === 32);
					var isEscape = (key === 'Escape') || (keyCode === 27);
					var isEnter = (key === 'Enter') || (keyCode === 13);
					return (isEscape || (isSpace || isEnter)) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{cQ: true})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 9:
					var shiftKey = msg.a.c_;
					var altKey = msg.a.cy;
					var ctrlKey = msg.a.cG;
					var metaKey = msg.a.cS;
					var key = msg.b;
					var keyCode = msg.c;
					var isSpace = (key === 'Space') || (keyCode === 32);
					var isEscape = (key === 'Escape') || (keyCode === 27);
					var isEnter = (key === 'Enter') || (keyCode === 13);
					return A2(
						$elm$core$Tuple$mapFirst,
						$elm$core$Maybe$map(
							function (newModel) {
								return _Utils_update(
									newModel,
									{cQ: false});
							}),
						((isEscape || (isSpace || isEnter)) && ((!(altKey || (ctrlKey || metaKey))) && model.cQ)) ? A3($author$project$Internal$Menu$Implementation$update, lift, $author$project$Internal$Menu$Model$Close, model) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none));
				default:
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (maybeNewList) {
							if (!maybeNewList.$) {
								var newList = maybeNewList.a;
								return $elm$core$Maybe$Just(
									_Utils_update(
										model,
										{dG: newList}));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A3(
							$author$project$Internal$List$Implementation$update,
							A2($elm$core$Basics$composeL, lift, $author$project$Internal$Menu$Model$ListMsg),
							msg_,
							model.dG));
			}
		}
	});
var $author$project$Internal$Menu$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Menu$Implementation$getSet.a5, $author$project$Internal$Menu$Implementation$getSet.cl, $author$project$Internal$Msg$MenuMsg, $author$project$Internal$Menu$Implementation$update);
var $author$project$Internal$Msg$RadioButtonMsg = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Internal$RadioButton$Model$defaultModel = {eT: false, _: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$RadioButton$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.d_;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{d_: x});
		}),
	$author$project$Internal$RadioButton$Model$defaultModel);
var $author$project$Internal$RadioButton$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$RadioButton$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model._);
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{_: ripple})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, lift, $author$project$Internal$RadioButton$Model$RippleMsg),
						effects));
			case 1:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			default:
				var focus = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{eT: focus})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$RadioButton$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$RadioButton$Implementation$getSet.a5, $author$project$Internal$RadioButton$Implementation$getSet.cl, $author$project$Internal$Msg$RadioButtonMsg, $author$project$Internal$RadioButton$Implementation$update);
var $author$project$Internal$Msg$RippleMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Internal$Ripple$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $._;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{_: x});
		}),
	$author$project$Internal$Ripple$Model$defaultModel);
var $author$project$Internal$Ripple$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Ripple$Implementation$getSet.a5,
	$author$project$Internal$Ripple$Implementation$getSet.cl,
	$author$project$Internal$Msg$RippleMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Ripple$Implementation$update));
var $author$project$Internal$Msg$SelectMsg = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Internal$Select$Model$defaultModel = {bY: false, dA: false, _: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Select$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.d7;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{d7: x});
		}),
	$author$project$Internal$Select$Model$defaultModel);
var $author$project$Internal$Select$Model$RippleMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Internal$Select$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 2:
				var changedValue = msg.a;
				var dirty = changedValue !== '';
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{dA: dirty})),
					$elm$core$Platform$Cmd$none);
			case 0:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bY: false})),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bY: true})),
					$elm$core$Platform$Cmd$none);
			default:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model._);
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{_: ripple})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, lift, $author$project$Internal$Select$Model$RippleMsg),
						effects));
		}
	});
var $author$project$Internal$Select$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Select$Implementation$getSet.a5, $author$project$Internal$Select$Implementation$getSet.cl, $author$project$Internal$Msg$SelectMsg, $author$project$Internal$Select$Implementation$update);
var $author$project$Internal$Msg$SliderMsg = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Internal$Slider$Model$defaultModel = {K: false, aW: $elm$core$Maybe$Nothing, bW: false, as: $elm$core$Maybe$Nothing, a6: false, cd: false};
var $author$project$Internal$Slider$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.ea;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{ea: x});
		}),
	$author$project$Internal$Slider$Model$defaultModel);
var $author$project$Internal$Slider$Model$ActualUp = {$: 11};
var $author$project$Internal$Slider$Model$Init = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Slider$Model$defaultGeometry = {
	U: false,
	b3: 100,
	b5: 0,
	bp: {p: 0, et: 0},
	cp: $elm$core$Maybe$Nothing
};
var $author$project$Internal$Slider$Implementation$valueFromPageX = F2(
	function (geometry, pageX) {
		var xPos = pageX - geometry.bp.p;
		var isRtl = false;
		var pctComplete = isRtl ? (1 - (xPos / geometry.bp.et)) : (xPos / geometry.bp.et);
		return geometry.b5 + (pctComplete * (geometry.b3 - geometry.b5));
	});
var $author$project$Internal$Slider$Implementation$update = F3(
	function (lift, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 5:
					return (!model.cd) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bW: true})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 6:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bW: false, cd: false})),
						$elm$core$Platform$Cmd$none);
				case 8:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{a6: false})),
						$elm$core$Platform$Cmd$none);
				case 3:
					var pageX = msg.b.dM;
					var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.as);
					var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									K: true,
									aW: $elm$core$Maybe$Just(activeValue),
									a6: true,
									cd: true
								})),
						$elm$core$Platform$Cmd$none);
				case 7:
					var pageX = msg.b.dM;
					var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.as);
					var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									K: true,
									aW: $elm$core$Maybe$Just(activeValue),
									a6: false,
									cd: true
								})),
						$elm$core$Platform$Cmd$none);
				case 9:
					var pageX = msg.a.dM;
					if (model.K) {
						var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.as);
						var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_update(
									model,
									{
										aW: $elm$core$Maybe$Just(activeValue),
										a6: false
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				case 1:
					var geometry = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									as: $elm$core$Maybe$Just(geometry)
								})),
						$elm$core$Platform$Cmd$none);
				case 2:
					var geometry = msg.a;
					var $temp$lift = lift,
						$temp$msg = $author$project$Internal$Slider$Model$Init(geometry),
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 4:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bW: true})),
						$elm$core$Platform$Cmd$none);
				case 10:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(model),
						A2(
							$elm$core$Task$perform,
							lift,
							$elm$core$Task$succeed($author$project$Internal$Slider$Model$ActualUp)));
				default:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{K: false, aW: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Internal$Slider$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Slider$Implementation$getSet.a5, $author$project$Internal$Slider$Implementation$getSet.cl, $author$project$Internal$Msg$SliderMsg, $author$project$Internal$Slider$Implementation$update);
var $author$project$Internal$Msg$SnackbarMsg = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Internal$Snackbar$Model$Inert = {$: 0};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Internal$Snackbar$Model$defaultModel = {o: false, cg: _List_Nil, aS: -1, co: $author$project$Internal$Snackbar$Model$Inert};
var $author$project$Internal$Snackbar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.bx;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{bx: x});
		}),
	$author$project$Internal$Snackbar$Model$defaultModel);
var $author$project$Internal$Snackbar$Model$Clicked = 1;
var $author$project$Internal$Snackbar$Model$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Helpers$cmd = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Internal$Snackbar$Model$Fading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Snackbar$Model$Timeout = 0;
var $author$project$Internal$Snackbar$Implementation$next = function (model) {
	return $elm$core$Platform$Cmd$map(
		$author$project$Internal$Snackbar$Model$Move(model.aS));
};
var $author$project$Internal$Snackbar$Model$Active = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Snackbar$Implementation$tryDequeue = function (model) {
	var _v0 = _Utils_Tuple2(model.co, model.cg);
	if ((!_v0.a.$) && _v0.b.b) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		var c = _v2.a;
		var cs = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					o: false,
					cg: cs,
					aS: model.aS + 1,
					co: $author$project$Internal$Snackbar$Model$Active(c)
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Internal$Snackbar$Model$Move(model.aS + 1),
				A2($author$project$Internal$Helpers$delayedCmd, c.c3, 0)));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Internal$Snackbar$Implementation$move = F2(
	function (transition, model) {
		var _v0 = _Utils_Tuple2(model.co, transition);
		if (_v0.b === 1) {
			if (_v0.a.$ === 1) {
				var contents = _v0.a.a;
				var _v3 = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							co: $author$project$Internal$Snackbar$Model$Fading(contents)
						}),
					A2(
						$author$project$Internal$Snackbar$Implementation$next,
						model,
						A2($author$project$Internal$Helpers$delayedCmd, contents.bV, 0)));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $author$project$Internal$Snackbar$Implementation$tryDequeue(model);
				case 1:
					var contents = _v0.a.a;
					var _v4 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								co: $author$project$Internal$Snackbar$Model$Fading(contents)
							}),
						A2(
							$author$project$Internal$Snackbar$Implementation$next,
							model,
							A2($author$project$Internal$Helpers$delayedCmd, contents.bV, 0)));
				default:
					var contents = _v0.a.a;
					var _v5 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{co: $author$project$Internal$Snackbar$Model$Inert}),
						A2(
							$author$project$Internal$Snackbar$Implementation$next,
							model,
							$author$project$Internal$Helpers$cmd(0)));
			}
		}
	});
var $author$project$Internal$Snackbar$Implementation$update = F3(
	function (fwd, msg, model) {
		switch (msg.$) {
			case 0:
				var seq = msg.a;
				var transition = msg.b;
				return _Utils_eq(seq, model.aS) ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(fwd),
					A2($author$project$Internal$Snackbar$Implementation$move, transition, model)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var dismissOnAction = msg.a;
				var actionOnDismiss = msg.b;
				var fwdEffect = function () {
					if (!actionOnDismiss.$) {
						var msg_ = actionOnDismiss.a;
						return $author$project$Internal$Helpers$cmd(msg_);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, fwdEffect]));
					},
					dismissOnAction ? A3(
						$author$project$Internal$Snackbar$Implementation$update,
						fwd,
						A2($author$project$Internal$Snackbar$Model$Move, model.aS, 1),
						model) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{o: true}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Snackbar$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Snackbar$Implementation$getSet.a5,
	$author$project$Internal$Snackbar$Implementation$getSet.cl,
	$author$project$Internal$Msg$SnackbarMsg,
	F3(
		function (fwd, msg, model) {
			return A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A3($author$project$Internal$Snackbar$Implementation$update, fwd, msg, model));
		}));
var $author$project$Internal$Msg$SwitchMsg = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Internal$Switch$Model$defaultModel = {eT: false, _: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Switch$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.eg;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{eg: x});
		}),
	$author$project$Internal$Switch$Model$defaultModel);
var $author$project$Internal$Switch$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Switch$Implementation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model._);
				var rippleState = _v1.a;
				var rippleCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{_: rippleState}),
					A2($elm$core$Platform$Cmd$map, $author$project$Internal$Switch$Model$RippleMsg, rippleCmd));
			case 1:
				var focus = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eT: focus}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Switch$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Switch$Implementation$getSet.a5,
	$author$project$Internal$Switch$Implementation$getSet.cl,
	$author$project$Internal$Msg$SwitchMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Switch$Implementation$update));
var $author$project$Internal$Msg$TabBarMsg = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Internal$TabBar$Model$defaultModel = {r: 0, as: $elm$core$Maybe$Nothing, bq: $elm$core$Dict$empty, eq: 0};
var $author$project$Internal$TabBar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.ei;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{ei: x});
		}),
	$author$project$Internal$TabBar$Model$defaultModel);
var $author$project$Internal$TabBar$Model$NoOp = {$: 0};
var $author$project$Internal$TabBar$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Internal$TabBar$Implementation$calculateScrollIncrement = F5(
	function (geometry, index, nextIndex, scrollPosition, barWidth) {
		var maybe_next_tab = $elm$core$List$head(
			A2($elm$core$List$drop, nextIndex, geometry.by));
		var extraScrollAmount = 20;
		if (!maybe_next_tab.$) {
			var next_tab = maybe_next_tab.a;
			var relativeContentRight = next_tab.cE - scrollPosition;
			var relativeContentLeft = (next_tab.cD - scrollPosition) - barWidth;
			var rightIncrement = relativeContentLeft + extraScrollAmount;
			var leftIncrement = relativeContentRight - extraScrollAmount;
			return (_Utils_cmp(nextIndex, index) < 0) ? A2($elm$core$Basics$min, leftIncrement, 0) : A2($elm$core$Basics$max, rightIncrement, 0);
		} else {
			return 0;
		}
	});
var $author$project$Internal$TabBar$Model$defaultGeometry = {
	d5: {G: 0},
	eh: {G: 0},
	by: _List_Nil
};
var $author$project$Internal$TabBar$Implementation$findAdjacentTabIndexClosestToEdge = F4(
	function (index, tab_, scrollPosition, barWidth) {
		var rootRight = tab_.aK + tab_.G;
		var rootLeft = tab_.aK;
		var relativeRootRight = (rootRight - scrollPosition) - barWidth;
		var relativeRootLeft = rootLeft - scrollPosition;
		var relativeRootDelta = relativeRootLeft + relativeRootRight;
		var rightEdgeIsCloser = (relativeRootRight > 0) || (relativeRootDelta > 0);
		var leftEdgeIsCloser = (relativeRootLeft < 0) || (relativeRootDelta < 0);
		return leftEdgeIsCloser ? (index - 1) : (rightEdgeIsCloser ? (index + 1) : (-1));
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Internal$TabBar$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 2:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.bq)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bq: A3($elm$core$Dict$insert, index, ripple, model.bq)
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							lift,
							$author$project$Internal$TabBar$Model$RippleMsg(index)),
						effects));
			case 1:
				var msgs = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Internal$Dispatch$forward(msgs));
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 3:
				var geometry = msg.a;
				return _Utils_Tuple2(
					function () {
						var tabBarWidth = geometry.eh.G;
						var scrollAreaWidth = geometry.d5.G;
						var isOverflowing = _Utils_cmp(tabBarWidth, scrollAreaWidth) > 0;
						var translateOffset = (!isOverflowing) ? 0 : model.eq;
						return $elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									as: $elm$core$Maybe$Just(geometry),
									eq: translateOffset
								}));
					}(),
					$elm$core$Platform$Cmd$none);
			default:
				var domId = msg.a;
				var tab_index = msg.b;
				var scrollPosition = msg.c;
				var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$TabBar$Model$defaultGeometry, model.as);
				var tabAtIndex = function (i) {
					return A2(
						$elm$core$Maybe$withDefault,
						{cD: 0, cE: 0, aK: 0, G: 0},
						$elm$core$List$head(
							A2($elm$core$List$drop, i, geometry.by)));
				};
				var tab_ = tabAtIndex(tab_index);
				var barWidth = geometry.eh.G;
				var next_tab_index = A4($author$project$Internal$TabBar$Implementation$findAdjacentTabIndexClosestToEdge, tab_index, tab_, scrollPosition, barWidth);
				var scrollIncrement = A5($author$project$Internal$TabBar$Implementation$calculateScrollIncrement, geometry, tab_index, next_tab_index, scrollPosition, barWidth);
				var newScrollPosition = (!tab_index) ? 0 : (_Utils_eq(
					tab_index,
					$elm$core$List$length(geometry.by) - 1) ? geometry.d5.G : (scrollPosition + scrollIncrement));
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{r: tab_index})),
					A2(
						$elm$core$Task$perform,
						lift,
						A2(
							$elm$core$Task$onError,
							function (_v3) {
								return $elm$core$Task$succeed($author$project$Internal$TabBar$Model$NoOp);
							},
							A2(
								$elm$core$Task$map,
								function (_v2) {
									return $author$project$Internal$TabBar$Model$NoOp;
								},
								A3($elm$browser$Browser$Dom$setViewportOf, domId + '__scroll-area', newScrollPosition, 0)))));
		}
	});
var $author$project$Internal$TabBar$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$TabBar$Implementation$getSet.a5, $author$project$Internal$TabBar$Implementation$getSet.cl, $author$project$Internal$Msg$TabBarMsg, $author$project$Internal$TabBar$Implementation$update);
var $author$project$Internal$Msg$TextFieldMsg = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Internal$TextField$Model$defaultModel = {bY: false, as: $elm$core$Maybe$Nothing, dA: false, bG: $elm$core$Maybe$Nothing};
var $author$project$Internal$TextField$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.em;
	},
	F2(
		function (x, c) {
			return _Utils_update(
				c,
				{em: x});
		}),
	$author$project$Internal$TextField$Model$defaultModel);
var $author$project$Internal$TextField$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 2:
				var str = msg.a;
				var dirty = str !== '';
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								dA: dirty,
								bG: $elm$core$Maybe$Just(str)
							})),
					$elm$core$Platform$Cmd$none);
			case 0:
				var geometry = function () {
					var _v1 = model.bG;
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						return model.as;
					}
				}();
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bY: false, as: geometry})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var geometry = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bY: true,
								as: $elm$core$Maybe$Just(geometry)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$TextField$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$TextField$Implementation$getSet.a5, $author$project$Internal$TextField$Implementation$getSet.cl, $author$project$Internal$Msg$TextFieldMsg, $author$project$Internal$TextField$Implementation$update);
var $author$project$Internal$Msg$TopAppBarMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Internal$TopAppBar$Model$defaultModel = {S: 0, dB: true, bd: $elm$core$Maybe$Nothing, bq: $elm$core$Dict$empty, ee: $elm$core$Maybe$Nothing, J: $elm$core$Maybe$Nothing, cv: true};
var $author$project$Internal$TopAppBar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.en;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{en: x});
		}),
	$author$project$Internal$TopAppBar$Model$defaultModel);
var $author$project$Internal$TopAppBar$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Internal$TopAppBar$Implementation$checkForUpdate = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (topAppBarHeight) {
			var offscreenBoundaryTop = -topAppBarHeight;
			var hasAnyPixelsOnscreen = _Utils_cmp(model.S, offscreenBoundaryTop) > 0;
			var hasAnyPixelsOffscreen = model.S < 0;
			var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
			return partiallyShowing ? _Utils_Tuple2(
				_Utils_update(
					model,
					{cv: false}),
				true) : ((!model.cv) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{cv: true}),
				true) : ((!_Utils_eq(model.dB, hasAnyPixelsOnscreen)) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{dB: hasAnyPixelsOnscreen}),
				true) : _Utils_Tuple2(model, false)));
		},
		model.J);
};
var $author$project$Internal$TopAppBar$Implementation$moveTopAppBar = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var updatedModel = _v0.a;
			var partiallyShowing = _v0.b;
			return partiallyShowing ? A2(
				$elm$core$Maybe$map,
				function (topAppBarHeight) {
					var styleTop = function () {
						var maxTopAppBarHeight = 128;
						return (_Utils_cmp(
							$elm$core$Basics$abs(updatedModel.S),
							topAppBarHeight) > 0) ? (-maxTopAppBarHeight) : updatedModel.S;
					}();
					return _Utils_update(
						updatedModel,
						{
							ee: $elm$core$Maybe$Just(styleTop)
						});
				},
				updatedModel.J) : $elm$core$Maybe$Just(updatedModel);
		},
		$author$project$Internal$TopAppBar$Implementation$checkForUpdate(model));
};
var $author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler = F2(
	function (scrollPosition, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Internal$TopAppBar$Implementation$moveTopAppBar,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var topAppBarHeight = _v0.a;
						var lastScrollPosition = _v0.b;
						var isCurrentlyBeingResized = false;
						var currentScrollPosition = A2($elm$core$Basics$max, scrollPosition, 0);
						var diff = currentScrollPosition - lastScrollPosition;
						var currentAppBarOffsetTop = model.S - diff;
						var updatedAppBarOffsetTop = (!isCurrentlyBeingResized) ? ((currentAppBarOffsetTop > 0) ? 0 : ((_Utils_cmp(
							$elm$core$Basics$abs(currentAppBarOffsetTop),
							topAppBarHeight) > 0) ? (-topAppBarHeight) : currentAppBarOffsetTop)) : model.S;
						var updatedModel = _Utils_update(
							model,
							{
								S: updatedAppBarOffsetTop,
								bd: $elm$core$Maybe$Just(currentScrollPosition)
							});
						return A2(
							$elm$core$Maybe$withDefault,
							updatedModel,
							$author$project$Internal$TopAppBar$Implementation$moveTopAppBar(updatedModel));
					},
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (topAppBarHeight, lastScrollPosition) {
								return _Utils_Tuple2(topAppBarHeight, lastScrollPosition);
							}),
						model.J,
						model.bd))));
	});
var $author$project$Internal$TopAppBar$Implementation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.bq)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bq: A3($elm$core$Dict$insert, index, ripple, model.bq)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Internal$TopAppBar$Model$RippleMsg(index),
						effects));
			case 1:
				var scrollPosition = msg.a.az;
				var topAppBarHeight = msg.a.J;
				return _Utils_Tuple2(
					A2(
						$author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler,
						scrollPosition,
						_Utils_update(
							model,
							{
								bd: $elm$core$Maybe$Just(scrollPosition),
								J: $elm$core$Maybe$Just(topAppBarHeight)
							})),
					$elm$core$Platform$Cmd$none);
			case 3:
				var scrollPosition = msg.a.az;
				return _Utils_Tuple2(
					A2($author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler, scrollPosition, model),
					$elm$core$Platform$Cmd$none);
			default:
				var scrollPosition = msg.a.az;
				var topAppBarHeight = msg.a.J;
				var currentHeight = topAppBarHeight;
				var currentAppBarOffsetTop = model.S - (topAppBarHeight - currentHeight);
				var updatedModel = (!_Utils_eq(
					$elm$core$Maybe$Just(topAppBarHeight),
					model.J)) ? _Utils_update(
					model,
					{
						S: currentAppBarOffsetTop,
						J: $elm$core$Maybe$Just(currentHeight),
						cv: false
					}) : model;
				return _Utils_Tuple2(
					A2($author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler, scrollPosition, updatedModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$TopAppBar$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$TopAppBar$Implementation$getSet.a5,
	$author$project$Internal$TopAppBar$Implementation$getSet.cl,
	$author$project$Internal$Msg$TopAppBarMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$TopAppBar$Implementation$update));
var $author$project$Material$update_ = F3(
	function (lift, msg, store) {
		switch (msg.$) {
			case 0:
				var msgs = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Internal$Dispatch$forward(msgs));
			case 1:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Button$Implementation$react, lift, msg_, idx, store);
			case 2:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Checkbox$Implementation$react, lift, msg_, idx, store);
			case 3:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Chip$Implementation$react, lift, msg_, idx, store);
			case 4:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Dialog$Implementation$react, lift, msg_, idx, store);
			case 5:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Drawer$Implementation$react, lift, msg_, idx, store);
			case 6:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Fab$Implementation$react, lift, msg_, idx, store);
			case 7:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$IconButton$Implementation$react, lift, msg_, idx, store);
			case 8:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$List$Implementation$react, lift, msg_, idx, store);
			case 9:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Menu$Implementation$react, lift, msg_, idx, store);
			case 10:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$RadioButton$Implementation$react, lift, msg_, idx, store);
			case 11:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Ripple$Implementation$react, lift, msg_, idx, store);
			case 12:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Select$Implementation$react, lift, msg_, idx, store);
			case 13:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Slider$Implementation$react, lift, msg_, idx, store);
			case 14:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Snackbar$Implementation$react, lift, msg_, idx, store);
			case 15:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Switch$Implementation$react, lift, msg_, idx, store);
			case 16:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TabBar$Implementation$react, lift, msg_, idx, store);
			case 17:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TextField$Implementation$react, lift, msg_, idx, store);
			default:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TopAppBar$Implementation$react, lift, msg_, idx, store);
		}
	});
var $author$project$Material$update = F3(
	function (lift, msg, container) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$withDefault(container),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$map(
					function (mdc) {
						return _Utils_update(
							container,
							{b4: mdc});
					}),
				A3(
					$author$project$Material$update_,
					lift,
					msg,
					function ($) {
						return $.b4;
					}(container))));
	});
var $author$project$UI$Usecase$CheckQuestion = {$: 4};
var $author$project$UI$Usecase$GoFowerd = {$: 6};
var $author$project$Domain$Questionnaire$Answer$Range = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Questionnaire$Answer$RowString = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Questionnaire$Answer$Selections = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Domain$Questionnaire$AnsweredPaper$build = F2(
	function (paper, answers) {
		return {
			c7: answers,
			bP: $elm$time$Time$millisToPosix(0),
			bm: paper.eP
		};
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Domain$Questionnaire$Questions$get = function (n) {
	return $elm$core$Array$get(n - 1);
};
var $author$project$Domain$Questionnaire$State$Answering$updateQuestion = F2(
	function (n, state) {
		return A2(
			$elm$core$Maybe$map,
			function (x) {
				return _Utils_update(
					state,
					{z: n, T: x});
			},
			A2($author$project$Domain$Questionnaire$Questions$get, n, state.cf));
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Domain$Questionnaire$Questions$volume = $elm$core$Array$length;
var $author$project$Domain$Questionnaire$State$Answering$fromPaper = function (paper) {
	return A2(
		$author$project$Domain$Questionnaire$State$Answering$updateQuestion,
		1,
		_Utils_update(
			$author$project$Domain$Questionnaire$State$Answering$default,
			{
				cf: paper.cf,
				ay: $author$project$Domain$Questionnaire$Questions$volume(paper.cf),
				cm: paper.cm
			}));
};
var $author$project$Domain$Questionnaire$Answers$get = $elm$core$Dict$get;
var $author$project$Domain$Questionnaire$Answer$getRangeOrEmpty = function (answer) {
	if (answer.$ === 1) {
		var x = answer.a;
		return x;
	} else {
		return $author$project$Domain$Questionnaire$Range$empty;
	}
};
var $author$project$Domain$Questionnaire$Answer$getSelectionsOrEmpty = function (answer) {
	if (!answer.$) {
		var x = answer.a;
		return x;
	} else {
		return $author$project$Selections$empty;
	}
};
var $author$project$Domain$Questionnaire$Answer$getTextOrEmpty = function (answer) {
	if (answer.$ === 2) {
		var x = answer.a;
		return x;
	} else {
		return '';
	}
};
var $author$project$Domain$Questionnaire$State$Answering$Started = 1;
var $author$project$Domain$Questionnaire$State$Answering$Finished = 2;
var $author$project$Domain$Questionnaire$State$Answering$isFinished = function (state) {
	return (_Utils_cmp(state.z, state.ay) > -1) && (state.Z === 2);
};
var $author$project$Domain$Questionnaire$State$Answering$isStarted = function (state) {
	return (state.z > 0) && (state.Z === 1);
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{m: nodeList, j: nodeListSize, l: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $author$project$Selections$member = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Array$map(
			function ($) {
				return $.eP;
			}),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Array$toList,
			$elm$core$List$member(id)));
};
var $author$project$Selections$isSelected = F2(
	function (id, selections) {
		return A2(
			$author$project$Selections$member,
			id,
			A2(
				$elm$core$Array$filter,
				function ($) {
					return $.b$;
				},
				selections));
	});
var $author$project$Domain$Questionnaire$CheckAnswerOperation$run = F2(
	function (operation, answer) {
		switch (operation.$) {
			case 0:
				return false;
			case 1:
				var ops = operation.a;
				return A3(
					$elm$core$List$foldl,
					F2(
						function (a, b) {
							return a && b;
						}),
					true,
					A2(
						$elm$core$List$map,
						function (x) {
							return A2($author$project$Domain$Questionnaire$CheckAnswerOperation$run, x, answer);
						},
						ops));
			case 2:
				var ops = operation.a;
				return A3(
					$elm$core$List$foldl,
					F2(
						function (a, b) {
							return a || b;
						}),
					false,
					A2(
						$elm$core$List$map,
						function (x) {
							return A2($author$project$Domain$Questionnaire$CheckAnswerOperation$run, x, answer);
						},
						ops));
			case 3:
				var op = operation.a;
				return !A2($author$project$Domain$Questionnaire$CheckAnswerOperation$run, op, answer);
			default:
				var selectionId = operation.a;
				if (!answer.$) {
					var selections = answer.a;
					return A2($author$project$Selections$isSelected, selectionId, selections);
				} else {
					return false;
				}
		}
	});
var $author$project$Domain$Questionnaire$CheckAnswerRule$run = F3(
	function (rule, answers, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (x) {
					if ($elm$core$List$isEmpty(rule.aM)) {
						return x;
					} else {
						if (!id.$) {
							var id_ = id.a;
							return x && A2($elm$core$List$member, id_, rule.aM);
						} else {
							return x;
						}
					}
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Domain$Questionnaire$CheckAnswerOperation$run(rule.aL),
					A2($author$project$Domain$Questionnaire$Answers$get, rule.aZ, answers))));
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Domain$Questionnaire$CheckAnswerRules$toList = $elm$core$Dict$values;
var $author$project$Domain$Questionnaire$CheckAnswerRules$run = F3(
	function (rules, answers, id) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (a, b) {
					return a || b;
				}),
			false,
			A2(
				$elm$core$List$map,
				function (rule) {
					return A3($author$project$Domain$Questionnaire$CheckAnswerRule$run, rule, answers, id);
				},
				$author$project$Domain$Questionnaire$CheckAnswerRules$toList(rules)));
	});
var $author$project$Domain$Questionnaire$State$Answering$goBack = function (state) {
	return $author$project$Domain$Questionnaire$State$Answering$isFinished(state) ? $elm$core$Maybe$Just(
		_Utils_update(
			state,
			{Z: 1})) : ($author$project$Domain$Questionnaire$State$Answering$isStarted(state) ? ((state.z === 1) ? $elm$core$Maybe$Just(
		_Utils_update(
			state,
			{Z: 0})) : A2(
		$elm$core$Maybe$andThen,
		function (x) {
			return function (isSkiped) {
				return (isSkiped || (!x.T.a9)) ? $author$project$Domain$Questionnaire$State$Answering$goBack(x) : $elm$core$Maybe$Just(x);
			}(
				A3(
					$author$project$Domain$Questionnaire$CheckAnswerRules$run,
					x.cm,
					x.c7,
					$elm$core$Maybe$Just(x.T.eP)));
		},
		A2($author$project$Domain$Questionnaire$State$Answering$updateQuestion, state.z - 1, state))) : $elm$core$Maybe$Nothing);
};
var $author$project$Domain$Questionnaire$State$Answering$goFowerd = function (state) {
	return $author$project$Domain$Questionnaire$State$Answering$isFinished(state) ? $elm$core$Maybe$Nothing : (_Utils_eq(state.z, state.ay) ? $elm$core$Maybe$Just(
		_Utils_update(
			state,
			{Z: 2})) : A2(
		$elm$core$Maybe$andThen,
		function (x) {
			return function (isSkiped) {
				return (isSkiped || (!x.T.a9)) ? $author$project$Domain$Questionnaire$State$Answering$goFowerd(x) : $elm$core$Maybe$Just(x);
			}(
				A3(
					$author$project$Domain$Questionnaire$CheckAnswerRules$run,
					x.cm,
					x.c7,
					$elm$core$Maybe$Just(x.T.eP)));
		},
		A2($author$project$Domain$Questionnaire$State$Answering$updateQuestion, state.z + 1, state)));
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$Selections$update = F3(
	function (n, f, selections) {
		return A2(
			$elm$core$Maybe$map,
			function (x) {
				return A3($elm$core$Array$set, n, x, selections);
			},
			A2(
				$elm$core$Maybe$map,
				f,
				A2($elm$core$Array$get, n, selections)));
	});
var $author$project$Selections$selectOne = F2(
	function (n, selections) {
		return A3(
			$author$project$Selections$update,
			n,
			function (x) {
				return _Utils_update(
					x,
					{b$: true});
			},
			A2(
				$elm$core$Array$map,
				function (x) {
					return _Utils_update(
						x,
						{b$: false});
				},
				selections));
	});
var $author$project$Domain$Questionnaire$Answers$set = $elm$core$Dict$insert;
var $author$project$Domain$Questionnaire$State$Answering$setAnswer = F2(
	function (answer, state) {
		return _Utils_update(
			state,
			{
				c7: A3($author$project$Domain$Questionnaire$Answers$set, state.T.eP, answer, state.c7)
			});
	});
var $author$project$Domain$Questionnaire$State$Answering$start = function (state) {
	return A2(
		$author$project$Domain$Questionnaire$State$Answering$updateQuestion,
		1,
		_Utils_update(
			state,
			{Z: 1}));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Port$addWithCollection = _Platform_outgoingPort(
	'addWithCollection',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collection',
					$elm$core$Basics$identity($.eC)),
					_Utils_Tuple2(
					'collectionName',
					$elm$json$Json$Encode$string($.eD)),
					_Utils_Tuple2(
					'ref',
					$elm$json$Json$Encode$string($.e6)),
					_Utils_Tuple2(
					'value',
					$elm$core$Basics$identity($.bG))
				]));
	});
var $author$project$Json$Collection$Document = F2(
	function (id, value) {
		return {eP: id, bG: value};
	});
var $author$project$Json$Collection$document = $author$project$Json$Collection$Document;
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Domain$Questionnaire$Range$encode = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'min',
				$elm$json$Json$Encode$float(x.b5)),
				_Utils_Tuple2(
				'max',
				$elm$json$Json$Encode$float(x.b3)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$float(x.bG)),
				_Utils_Tuple2(
				'step',
				$elm$json$Json$Encode$float(x.cp))
			]));
};
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $elm$json$Json$Encode$array = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$Array$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Selection$encode = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(x.eP)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(x.bB)),
				_Utils_Tuple2(
				'isSelected',
				$elm$json$Json$Encode$bool(x.b$))
			]));
};
var $author$project$Selections$encode = $elm$json$Json$Encode$array($author$project$Selection$encode);
var $author$project$Domain$Questionnaire$Answer$encode = function (answer) {
	return $elm$json$Json$Encode$object(
		function () {
			switch (answer.$) {
				case 0:
					var x = answer.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Selections')),
							_Utils_Tuple2(
							'value',
							$author$project$Selections$encode(x))
						]);
				case 1:
					var x = answer.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Range')),
							_Utils_Tuple2(
							'value',
							$author$project$Domain$Questionnaire$Range$encode(x))
						]);
				default:
					var x = answer.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('RowString')),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(x))
						]);
			}
		}());
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Json$Collection$encode = $elm$json$Json$Encode$list(
	function (x) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(x.eP)),
					_Utils_Tuple2('value', x.bG)
				]));
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Domain$Questionnaire$Answers$encodeToCollection = function (answers) {
	return $author$project$Json$Collection$encode(
		$elm$core$Dict$values(
			A2(
				$elm$core$Dict$map,
				F2(
					function (k, v) {
						return A2(
							$author$project$Json$Collection$document,
							k,
							$author$project$Domain$Questionnaire$Answer$encode(v));
					}),
				answers)));
};
var $author$project$Infra$Repository$AnsweredPaper$store = function (answerdPaper) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Port$addWithCollection(
				{
					eC: $author$project$Domain$Questionnaire$Answers$encodeToCollection(answerdPaper.c7),
					eD: 'answers',
					e6: 'answerdPapers',
					bG: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'paperId',
								$elm$json$Json$Encode$string(answerdPaper.bm))
							]))
				})
			]));
};
var $author$project$Domain$Questionnaire$Question$Format$toDefaultAnswer = function (format) {
	switch (format.$) {
		case 0:
			var selectionSet = format.a;
			return $author$project$Domain$Questionnaire$Answer$Selections(selectionSet.aR);
		case 1:
			var selectionSet = format.a;
			return $author$project$Domain$Questionnaire$Answer$Selections(selectionSet.aR);
		case 2:
			var range = format.a;
			return $author$project$Domain$Questionnaire$Answer$Range(range);
		case 3:
			return $author$project$Domain$Questionnaire$Answer$RowString('');
		default:
			return $author$project$Domain$Questionnaire$Answer$RowString('');
	}
};
var $author$project$Selections$toggle = F2(
	function (n, selections) {
		return A3(
			$author$project$Selections$update,
			n,
			function (x) {
				return _Utils_update(
					x,
					{b$: !x.b$});
			},
			selections);
	});
var $author$project$UI$Usecase$update = F3(
	function (usecase, model, state) {
		var answering = state.c6;
		var sendLog = function (x) {
			if (!x.$) {
				var container = x.a;
				return container;
			} else {
				var error = x.a;
				return _Utils_Tuple2(
					state,
					$author$project$Infra$Logger$send(error));
			}
		};
		var send = F2(
			function (x, _v2) {
				var s = _v2.a;
				var c = _v2.b;
				var _v1 = A3($author$project$UI$Usecase$update, x, model, s);
				var s_ = _v1.a;
				var c_ = _v1.b;
				return _Utils_Tuple2(
					s_,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[c, c_])));
			});
		switch (usecase.$) {
			case 3:
				return A2(
					send,
					$author$project$UI$Usecase$CheckQuestion,
					sendLog(
						A2(
							$elm$core$Result$map,
							function (x) {
								return _Utils_Tuple2(
									_Utils_update(
										state,
										{c6: x}),
									$elm$core$Platform$Cmd$none);
							},
							A2(
								$elm$core$Result$fromMaybe,
								'Failed StartAnswer',
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Domain$Questionnaire$State$Answering$start,
									$author$project$Domain$Questionnaire$State$Answering$fromPaper(model.cc))))));
			case 4:
				return function (answer) {
					return _Utils_Tuple2(
						_Utils_update(
							state,
							{
								bu: $author$project$Domain$Questionnaire$Answer$getRangeOrEmpty(answer),
								d9: $author$project$Domain$Questionnaire$Answer$getSelectionsOrEmpty(answer),
								bv: $author$project$Domain$Questionnaire$Answer$getTextOrEmpty(answer)
							}),
						$elm$core$Platform$Cmd$none);
				}(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Domain$Questionnaire$Question$Format$toDefaultAnswer(answering.T.a3),
						A2($author$project$Domain$Questionnaire$Answers$get, answering.T.eP, answering.c7)));
			case 5:
				return A2(
					send,
					$author$project$UI$Usecase$CheckQuestion,
					sendLog(
						A2(
							$elm$core$Result$map,
							function (x) {
								return _Utils_Tuple2(
									_Utils_update(
										state,
										{c6: x}),
									$elm$core$Platform$Cmd$none);
							},
							A2(
								$elm$core$Result$fromMaybe,
								'Failed GoBack',
								$author$project$Domain$Questionnaire$State$Answering$goBack(answering)))));
			case 6:
				return A2(
					send,
					$author$project$UI$Usecase$CheckQuestion,
					sendLog(
						A2(
							$elm$core$Result$map,
							function (x) {
								return _Utils_Tuple2(
									_Utils_update(
										state,
										{c6: x}),
									$elm$core$Platform$Cmd$none);
							},
							A2(
								$elm$core$Result$fromMaybe,
								'Failed GoFowerd',
								$author$project$Domain$Questionnaire$State$Answering$goFowerd(answering)))));
			case 8:
				var n = usecase.a;
				var selection = usecase.b;
				return sendLog(
					A2(
						$elm$core$Result$map,
						function (x) {
							return _Utils_Tuple2(
								_Utils_update(
									state,
									{d9: x}),
								$elm$core$Platform$Cmd$none);
						},
						A2(
							$elm$core$Result$fromMaybe,
							'Selection not found.',
							A2($author$project$Selections$toggle, n, state.d9))));
			case 9:
				var n = usecase.a;
				var selection = usecase.b;
				return sendLog(
					A2(
						$elm$core$Result$map,
						function (x) {
							return _Utils_Tuple2(
								_Utils_update(
									state,
									{d9: x}),
								$elm$core$Platform$Cmd$none);
						},
						A2(
							$elm$core$Result$fromMaybe,
							'Selection not found.',
							A2($author$project$Selections$selectOne, n, state.d9))));
			case 10:
				return A2(
					send,
					$author$project$UI$Usecase$GoFowerd,
					_Utils_Tuple2(
						function (x) {
							return _Utils_update(
								state,
								{
									c6: A2($author$project$Domain$Questionnaire$State$Answering$setAnswer, x, answering)
								});
						}(
							$author$project$Domain$Questionnaire$Answer$Selections(state.d9)),
						$elm$core$Platform$Cmd$none));
			case 11:
				var range = usecase.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{bu: range}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return A2(
					send,
					$author$project$UI$Usecase$GoFowerd,
					_Utils_Tuple2(
						function (x) {
							return _Utils_update(
								state,
								{
									c6: A2($author$project$Domain$Questionnaire$State$Answering$setAnswer, x, answering)
								});
						}(
							$author$project$Domain$Questionnaire$Answer$Range(state.bu)),
						$elm$core$Platform$Cmd$none));
			case 13:
				var string = usecase.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{bv: string}),
					$elm$core$Platform$Cmd$none);
			case 14:
				return A2(
					send,
					$author$project$UI$Usecase$GoFowerd,
					_Utils_Tuple2(
						function (x) {
							return _Utils_update(
								state,
								{
									c6: A2($author$project$Domain$Questionnaire$State$Answering$setAnswer, x, answering)
								});
						}(
							$author$project$Domain$Questionnaire$Answer$RowString(state.bv)),
						$elm$core$Platform$Cmd$none));
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{eU: true}),
					$author$project$Infra$Repository$AnsweredPaper$store(
						A2($author$project$Domain$Questionnaire$AnsweredPaper$build, model.cc, state.c6.c7)));
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var url = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ai: $author$project$UI$Page$fromUrl(url),
							al: url
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var urlRequest = msg.a;
				return _Utils_Tuple2(
					model,
					function () {
						if (!urlRequest.$) {
							var url = urlRequest.a;
							return A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.cP,
								$elm$url$Url$toString(url));
						} else {
							var href = urlRequest.a;
							return $elm$browser$Browser$Navigation$load(href);
						}
					}());
			case 2:
				var m = msg.a;
				return A3($author$project$Material$update, $author$project$Main$Mdc, m, model);
			case 3:
				var usecase = msg.a;
				var _v2 = A3($author$project$UI$Usecase$update, usecase, model.aq, model.co);
				var state = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{co: state}),
					cmd);
			case 4:
				var x = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bH: x}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var x = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aq: A2($author$project$Domain$paper.cl, x, model.aq),
							ai: x.a9 ? $author$project$UI$Page$finishLoading(model.ai) : $author$project$UI$Page$notFound(model.al)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ai: $author$project$UI$Page$notFound(model.al)
						}),
					$author$project$Infra$Logger$sendError(error));
			default:
				var x = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cJ: x,
							ai: $author$project$UI$Page$notFound(model.al)
						}),
					$author$project$Infra$Logger$sendError(x));
		}
	});
var $author$project$Main$Usecase = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Widget$Typography$Body = 3;
var $author$project$UI$Widget$Button = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Widget$Typography$Caption = 4;
var $author$project$UI$Usecase$CheckProgress = {$: 7};
var $author$project$UI$Usecase$CheckProvider = {$: 2};
var $author$project$UI$Usecase$ClosePaper = {$: 16};
var $author$project$UI$Widget$Layout$Container = 0;
var $author$project$UI$Widget$Layout$Footer = 3;
var $author$project$UI$Usecase$GoBack = {$: 5};
var $author$project$UI$Widget$Layout = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$UI$Widget$LinearProgress = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Widget$Layout$Main = 1;
var $author$project$UI$Usecase$PageNotFound = {$: 0};
var $author$project$UI$Usecase$SendAnswer = {$: 15};
var $author$project$UI$Widget$Space = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$Usecase$StartAnswer = {$: 3};
var $author$project$UI$Widget$Typography$SubTitle = 2;
var $author$project$UI$Widget$Typography$Title = 1;
var $author$project$UI$Widget$Typography = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$UI$Widget$Checkbox = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$Usecase$ConfirmRange = {$: 12};
var $author$project$UI$Usecase$ConfirmSelections = {$: 10};
var $author$project$UI$Usecase$ConfirmText = {$: 14};
var $author$project$UI$Widget$Layout$Divide = 4;
var $author$project$UI$Usecase$EditRange = function (a) {
	return {$: 11, a: a};
};
var $author$project$UI$Usecase$EditText = function (a) {
	return {$: 13, a: a};
};
var $author$project$UI$Widget$RadioButton = function (a) {
	return {$: 7, a: a};
};
var $author$project$UI$Usecase$Select = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$UI$Usecase$SelectOne = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$UI$Widget$Layout$Selections = 5;
var $author$project$UI$Widget$Slider = function (a) {
	return {$: 8, a: a};
};
var $author$project$UI$Widget$TextField = function (a) {
	return {$: 9, a: a};
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return A3(
		$elm$core$Array$foldr,
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$Selections$toIndexedList = $elm$core$Array$toIndexedList;
var $author$project$UI$Page$answerForm = function (dep) {
	var state = dep.co;
	var _v0 = state.c6.T.a3;
	switch (_v0.$) {
		case 0:
			return A2(
				$author$project$UI$Widget$Layout,
				4,
				_List_fromArray(
					[
						A2(
						$author$project$UI$Widget$Layout,
						5,
						A2(
							$elm$core$List$map,
							$author$project$UI$Widget$Layout(4),
							A2(
								$elm$core$List$map,
								$elm$core$List$singleton,
								A2(
									$elm$core$List$map,
									$author$project$UI$Widget$Checkbox,
									A2(
										$elm$core$List$map,
										function (_v1) {
											var n = _v1.a;
											var selection = _v1.b;
											return A2($author$project$UI$Usecase$Select, n, selection);
										},
										$author$project$Selections$toIndexedList(state.d9)))))),
						$author$project$UI$Widget$Space('2rem'),
						$author$project$UI$Widget$Button($author$project$UI$Usecase$ConfirmSelections)
					]));
		case 1:
			return A2(
				$author$project$UI$Widget$Layout,
				4,
				_List_fromArray(
					[
						A2(
						$author$project$UI$Widget$Layout,
						5,
						A2(
							$elm$core$List$map,
							$author$project$UI$Widget$Layout(4),
							A2(
								$elm$core$List$map,
								$elm$core$List$singleton,
								A2(
									$elm$core$List$map,
									$author$project$UI$Widget$RadioButton,
									A2(
										$elm$core$List$map,
										function (_v2) {
											var n = _v2.a;
											var selection = _v2.b;
											return A2($author$project$UI$Usecase$SelectOne, n, selection);
										},
										$author$project$Selections$toIndexedList(state.d9)))))),
						$author$project$UI$Widget$Space('2rem'),
						$author$project$UI$Widget$Button($author$project$UI$Usecase$ConfirmSelections)
					]));
		case 2:
			return A2(
				$author$project$UI$Widget$Layout,
				4,
				_List_fromArray(
					[
						$author$project$UI$Widget$Slider($author$project$UI$Usecase$EditRange),
						$author$project$UI$Widget$Space('2rem'),
						$author$project$UI$Widget$Button($author$project$UI$Usecase$ConfirmRange)
					]));
		case 3:
			return A2(
				$author$project$UI$Widget$Layout,
				4,
				_List_fromArray(
					[
						$author$project$UI$Widget$TextField($author$project$UI$Usecase$EditText),
						$author$project$UI$Widget$Space('2rem'),
						$author$project$UI$Widget$Button($author$project$UI$Usecase$ConfirmText)
					]));
		default:
			return A2(
				$author$project$UI$Widget$Layout,
				4,
				_List_fromArray(
					[
						$author$project$UI$Widget$TextField($author$project$UI$Usecase$EditText),
						$author$project$UI$Widget$Space('2rem'),
						$author$project$UI$Widget$Button($author$project$UI$Usecase$ConfirmText)
					]));
	}
};
var $author$project$Index$new = $elm$core$List$singleton;
var $elm$core$Array$isEmpty = function (_v0) {
	var len = _v0.a;
	return !len;
};
var $author$project$Selections$areSelected = A2(
	$elm$core$Basics$composeR,
	$elm$core$Array$filter(
		function ($) {
			return $.b$;
		}),
	A2($elm$core$Basics$composeR, $elm$core$Array$isEmpty, $elm$core$Basics$not));
var $author$project$Internal$Options$Class = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Options$cs = function (c) {
	return $author$project$Internal$Options$Class(c);
};
var $author$project$Internal$Typography$Implementation$button = $author$project$Internal$Options$cs('mdc-typography--button');
var $author$project$Material$Typography$button = $author$project$Internal$Typography$Implementation$button;
var $author$project$Internal$Options$Set = function (a) {
	return {$: 5, a: a};
};
var $author$project$Internal$Options$option = $author$project$Internal$Options$Set;
var $author$project$Internal$Button$Implementation$disabled = $author$project$Internal$Options$option(
	function (options) {
		return _Utils_update(
			options,
			{aE: true});
	});
var $author$project$Material$Button$disabled = $author$project$Internal$Button$Implementation$disabled;
var $author$project$Internal$Options$Listener = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Internal$Options$on = F2(
	function (event, decodeMessage) {
		return A2(
			$author$project$Internal$Options$Listener,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (message) {
					return {dI: message, dT: false, ed: false};
				},
				decodeMessage));
	});
var $author$project$Internal$Options$onClick = function (msg) {
	return A2(
		$author$project$Internal$Options$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Material$Options$onClick = $author$project$Internal$Options$onClick;
var $author$project$Internal$Button$Implementation$raised = $author$project$Internal$Options$cs('mdc-button--raised');
var $author$project$Material$Button$raised = $author$project$Internal$Button$Implementation$raised;
var $author$project$Internal$Button$Implementation$ripple = $author$project$Internal$Options$option(
	function (options) {
		return _Utils_update(
			options,
			{_: true});
	});
var $author$project$Material$Button$ripple = $author$project$Internal$Button$Implementation$ripple;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Index$add = F2(
	function (id, index) {
		return A2($elm$core$List$cons, id, index);
	});
var $author$project$Index$toString = F2(
	function (id, index) {
		return A2(
			$elm$core$String$join,
			'_',
			$elm$core$List$reverse(
				A2($author$project$Index$add, id, index)));
	});
var $author$project$Internal$Button$Model$Click = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Internal$Dispatch$flatten = function (decoders) {
	var tryMergeStep = F3(
		function (value, decoder, result) {
			return A2(
				$elm$core$Maybe$withDefault,
				result,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var message = _v0.dI;
						var stopPropagation = _v0.ed;
						var preventDefault = _v0.dT;
						return {
							dI: A2($elm$core$List$cons, message, result.dI),
							dT: preventDefault || result.dT,
							ed: stopPropagation || result.ed
						};
					},
					$elm$core$Result$toMaybe(
						A2($elm$json$Json$Decode$decodeValue, decoder, value))));
		});
	var tryMerge = function (value) {
		return A3(
			$elm$core$List$foldl,
			tryMergeStep(value),
			{dI: _List_Nil, dT: false, ed: false},
			decoders);
	};
	return A2($elm$json$Json$Decode$map, tryMerge, $elm$json$Json$Decode$value);
};
var $author$project$Internal$Dispatch$toAttributes = function (_v0) {
	var config = _v0;
	var _v1 = config.cR;
	if (!_v1.$) {
		var lift = _v1.a;
		return A2(
			$elm$core$List$map,
			function (_v3) {
				var event = _v3.a;
				var flatDecoder = _v3.b;
				return A2(
					$elm$html$Html$Events$custom,
					event,
					lift(flatDecoder));
			},
			$elm$core$Dict$toList(
				A2(
					$elm$core$Dict$map,
					function (_v2) {
						return $author$project$Internal$Dispatch$flatten;
					},
					config.af)));
	} else {
		return A2(
			$elm$core$List$concatMap,
			function (_v4) {
				var event = _v4.a;
				var decoders = _v4.b;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$Events$custom(event),
					decoders);
			},
			$elm$core$Dict$toList(config.af));
	}
};
var $author$project$Internal$Options$addAttributes = F2(
	function (summary, attrs) {
		var styleText = A2(
			$elm$core$String$join,
			'; ',
			A2(
				$elm$core$List$map,
				function (_v0) {
					var key = _v0.a;
					var value = _v0.b;
					return A2(
						$elm$core$String$join,
						': ',
						_List_fromArray(
							[key, value]));
				},
				summary.ap));
		var style = (styleText !== '') ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'style', styleText)
			]) : _List_Nil;
		var all = _Utils_ap(
			summary.an,
			_Utils_ap(
				style,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$html$Html$Attributes$class,
						$elm$core$List$reverse(summary.ao)),
					_Utils_ap(
						attrs,
						_Utils_ap(
							summary.au,
							$author$project$Internal$Dispatch$toAttributes(summary.B))))));
		return all;
	});
var $author$project$Internal$Dispatch$Config = $elm$core$Basics$identity;
var $author$project$Internal$Dispatch$add = F3(
	function (event, decoder, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				af: A3(
					$elm$core$Dict$update,
					event,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$cons(decoder)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(
								_List_fromArray(
									[decoder])),
							$elm$core$Maybe$Just)),
					config.af)
			});
	});
var $author$project$Internal$Dispatch$setLift = F2(
	function (lift, _v0) {
		var decoders = _v0.af;
		return {
			af: decoders,
			cR: $elm$core$Maybe$Just(lift)
		};
	});
var $author$project$Internal$Options$collect1 = F2(
	function (opt, acc) {
		switch (opt.$) {
			case 0:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						ao: A2($elm$core$List$cons, x, acc.ao)
					});
			case 1:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						ap: A2($elm$core$List$cons, x, acc.ap)
					});
			case 2:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						an: A2($elm$core$List$cons, x, acc.an)
					});
			case 3:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						au: A2($elm$core$List$cons, x, acc.au)
					});
			case 4:
				var opts = opt.a;
				return A3($elm$core$List$foldl, $author$project$Internal$Options$collect1, acc, opts);
			case 5:
				var g = opt.a;
				return _Utils_update(
					acc,
					{
						de: g(acc.de)
					});
			case 6:
				var event = opt.a;
				var decoder = opt.b;
				return _Utils_update(
					acc,
					{
						B: A3($author$project$Internal$Dispatch$add, event, decoder, acc.B)
					});
			case 7:
				var lift = opt.a;
				return _Utils_update(
					acc,
					{
						B: A2($author$project$Internal$Dispatch$setLift, lift, acc.B)
					});
			default:
				return acc;
		}
	});
var $author$project$Internal$Options$recollect = $elm$core$List$foldl($author$project$Internal$Options$collect1);
var $author$project$Internal$Options$apply = F4(
	function (summary, ctor, options, attrs) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				A2($author$project$Internal$Options$recollect, summary, options),
				attrs));
	});
var $author$project$Internal$Options$Attribute = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Internal$Options$attribute = A2(
	$elm$core$Basics$composeL,
	$author$project$Internal$Options$Attribute,
	$elm$html$Html$Attributes$map($elm$core$Basics$never));
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Internal$Options$Summary = F6(
	function (classes, css, attrs, internal, dispatch, config) {
		return {an: attrs, ao: classes, de: config, ap: css, B: dispatch, au: internal};
	});
var $author$project$Internal$Dispatch$defaultConfig = {af: $elm$core$Dict$empty, cR: $elm$core$Maybe$Nothing};
var $author$project$Internal$Options$collect = A2(
	$elm$core$Basics$composeR,
	A5($author$project$Internal$Options$Summary, _List_Nil, _List_Nil, _List_Nil, _List_Nil, $author$project$Internal$Dispatch$defaultConfig),
	$author$project$Internal$Options$recollect);
var $author$project$Internal$Button$Implementation$defaultConfig = {aE: false, aI: $elm$core$Maybe$Nothing, aJ: $elm$core$Maybe$Nothing, b8: $elm$core$Maybe$Nothing, _: false, bC: false};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Internal$Options$Many = function (a) {
	return {$: 4, a: a};
};
var $author$project$Internal$Options$many = $author$project$Internal$Options$Many;
var $author$project$Internal$Options$None = {$: 8};
var $author$project$Internal$Options$nop = $author$project$Internal$Options$None;
var $author$project$Internal$Options$aria = F2(
	function (key, val) {
		return $author$project$Internal$Options$Attribute(
			A2($elm$html$Html$Attributes$attribute, 'aria-' + key, val));
	});
var $author$project$Internal$Icon$Implementation$defaultConfig = {b7: 'i'};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Internal$Icon$Implementation$view = F2(
	function (options, name) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Icon$Implementation$defaultConfig, options);
		var config = summary.de;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$node(config.b7),
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('material-icons'),
					A2($author$project$Internal$Options$aria, 'hidden', 'true')
				]),
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Internal$Ripple$Model$Blur = {$: 1};
var $author$project$Internal$Ripple$Model$Deactivate = {$: 6};
var $author$project$Internal$Ripple$Model$Focus = {$: 0};
var $author$project$Internal$Ripple$Model$SetCssVariables = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$activationEventTypes = _List_fromArray(
	['touchstart', 'pointerdown', 'mousedown']);
var $author$project$Internal$Ripple$Model$cssClasses = {ey: 'mdc-ripple-upgraded--background-focused', eL: 'mdc-ripple-upgraded--foreground-activation', eM: 'mdc-ripple-upgraded--foreground-deactivation', e8: 'mdc-ripple-upgraded', fb: 'mdc-ripple-upgraded--unbounded'};
var $author$project$Internal$Options$CSS = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Options$css = F2(
	function (key, value) {
		return $author$project$Internal$Options$CSS(
			_Utils_Tuple2(key, value));
	});
var $elm$core$Basics$round = _Basics_round;
var $author$project$Internal$Ripple$Model$strings = {fc: '--mdc-ripple-fg-scale', fd: '--mdc-ripple-fg-size', fe: '--mdc-ripple-fg-translate-end', ff: '--mdc-ripple-fg-translate-start', fg: '--mdc-ripple-left', fh: '--mdc-ripple-top'};
var $author$project$Internal$Ripple$Implementation$cssVariables = F2(
	function (isUnbounded, _v0) {
		var fgScale = _v0.N;
		var translateStart = _v0.ab;
		var translateEnd = _v0.aa;
		var initialSize = _v0.P;
		var frame = _v0.V;
		var unboundedCoords = isUnbounded ? {
			p: $elm$core$Basics$round((frame.et - initialSize) / 2),
			i: $elm$core$Basics$round((frame.g - initialSize) / 2)
		} : {p: 0, i: 0};
		var fgSize = $elm$core$String$fromInt(initialSize) + 'px';
		var variables = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($author$project$Internal$Options$css, $author$project$Internal$Ripple$Model$strings.fd, fgSize),
						A2(
						$author$project$Internal$Options$css,
						$author$project$Internal$Ripple$Model$strings.fc,
						$elm$core$String$fromFloat(fgScale))
					]),
					isUnbounded ? _List_fromArray(
					[
						A2(
						$author$project$Internal$Options$css,
						$author$project$Internal$Ripple$Model$strings.fh,
						$elm$core$String$fromFloat(unboundedCoords.i) + 'px'),
						A2(
						$author$project$Internal$Options$css,
						$author$project$Internal$Ripple$Model$strings.fg,
						$elm$core$String$fromFloat(unboundedCoords.p) + 'px')
					]) : _List_fromArray(
					[
						A2($author$project$Internal$Options$css, $author$project$Internal$Ripple$Model$strings.ff, translateStart),
						A2($author$project$Internal$Options$css, $author$project$Internal$Ripple$Model$strings.fe, translateEnd)
					])
				]));
		return variables;
	});
var $author$project$Internal$Options$data = F2(
	function (key, val) {
		return $author$project$Internal$Options$Attribute(
			A2($elm$html$Html$Attributes$attribute, 'data-' + key, val));
	});
var $author$project$Internal$Ripple$Model$Activate0 = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Event = F2(
	function (eventType, pagePoint) {
		return {a2: eventType, e4: pagePoint};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Internal$Ripple$Implementation$decodeActivate = function (_v0) {
	var domId = _v0.dj;
	var isUnbounded = _v0.bb;
	var isActivated = _v0.dz;
	var previousActivationEvent = _v0.dU;
	var decodePagePoint = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (pageX, pageY) {
				return {dM: pageX, dN: pageY};
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['pageX']),
			$elm$json$Json$Decode$float),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['pageY']),
			$elm$json$Json$Decode$float));
	var firstChangedTouch = A2(
		$elm$json$Json$Decode$andThen,
		function (changedTouches) {
			var _v3 = $elm$core$List$head(changedTouches);
			if (!_v3.$) {
				var pagePoint = _v3.a;
				return $elm$json$Json$Decode$succeed(pagePoint);
			} else {
				return $elm$json$Json$Decode$fail('');
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['changedTouches']),
			$elm$json$Json$Decode$list(decodePagePoint)));
	var decodeIsSurfaceDisabled = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$always(true),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['disabled']),
					$elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed(false)
			]));
	var decodeEventType = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['type']),
		$elm$json$Json$Decode$string);
	var decodeIsSameInteraction = function () {
		if (previousActivationEvent.$ === 1) {
			return $elm$json$Json$Decode$succeed(false);
		} else {
			var event = previousActivationEvent.a;
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$eq(event.a2),
				decodeEventType);
		}
	}();
	var decodeEvent = A2(
		$elm$json$Json$Decode$andThen,
		function (eventType) {
			if (eventType === 'touchstart') {
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Internal$Ripple$Model$Event(eventType),
					firstChangedTouch);
			} else {
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Internal$Ripple$Model$Event(eventType),
					decodePagePoint);
			}
		},
		decodeEventType);
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail(''))),
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (isSurfaceDisabled, isSameInteraction, event) {
					return (isActivated || (isSurfaceDisabled || isSameInteraction)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							$author$project$Internal$Ripple$Model$Activate0,
							domId,
							{a1: event, eV: false, bb: isUnbounded, c4: false}));
				}),
			decodeIsSurfaceDisabled,
			decodeIsSameInteraction,
			decodeEvent));
};
var $author$project$Internal$Ripple$Model$ClientRect = F4(
	function (top, left, width, height) {
		return {g: height, p: left, i: top, et: width};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $debois$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Internal$Ripple$Implementation$decodeClientRect = $debois$elm_dom$DOM$target(
	A5($elm$json$Json$Decode$map4, $author$project$Internal$Ripple$Model$ClientRect, $debois$elm_dom$DOM$offsetTop, $debois$elm_dom$DOM$offsetLeft, $debois$elm_dom$DOM$offsetWidth, $debois$elm_dom$DOM$offsetHeight));
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Internal$Options$id = A2($elm$core$Basics$composeL, $author$project$Internal$Options$Attribute, $elm$html$Html$Attributes$id);
var $author$project$Material$Options$data = $author$project$Internal$Options$data;
var $author$project$Material$Options$many = $author$project$Internal$Options$many;
var $author$project$Material$Options$on = $author$project$Internal$Options$on;
var $author$project$Internal$GlobalEvents$listener = F2(
	function (name, decoder) {
		return $author$project$Material$Options$many(
			_List_fromArray(
				[
					A2($author$project$Material$Options$on, name, decoder),
					A2($author$project$Material$Options$data, name, '{}')
				]));
	});
var $author$project$Internal$GlobalEvents$onMouseUp = $author$project$Internal$GlobalEvents$listener('globalmouseup');
var $author$project$Internal$GlobalEvents$onPointerUp = $author$project$Internal$GlobalEvents$listener('globalpointerup');
var $author$project$Internal$GlobalEvents$onTick = $author$project$Internal$GlobalEvents$listener('globaltick');
var $author$project$Internal$GlobalEvents$onTouchEnd = $author$project$Internal$GlobalEvents$listener('globaltouchend');
var $author$project$Internal$Options$when = F2(
	function (guard, prop) {
		return guard ? prop : $author$project$Internal$Options$nop;
	});
var $author$project$Internal$Ripple$Implementation$view = F5(
	function (isUnbounded, domId, lift, model, options) {
		var noStyle = $elm$html$Html$text('');
		var focusHandler = A2(
			$author$project$Internal$Options$on,
			'focus',
			$elm$json$Json$Decode$succeed(
				lift($author$project$Internal$Ripple$Model$Focus)));
		var deactivateHandler = function (event) {
			var deactivate = $elm$json$Json$Decode$succeed(
				lift($author$project$Internal$Ripple$Model$Deactivate));
			return $author$project$Internal$Options$many(
				_List_fromArray(
					[
						$author$project$Internal$GlobalEvents$onTouchEnd(deactivate),
						$author$project$Internal$GlobalEvents$onMouseUp(deactivate),
						$author$project$Internal$GlobalEvents$onPointerUp(deactivate)
					]));
		};
		var blurHandler = A2(
			$author$project$Internal$Options$on,
			'blur',
			$elm$json$Json$Decode$succeed(
				lift($author$project$Internal$Ripple$Model$Blur)));
		var baseProperties = $author$project$Internal$Options$many(
			_List_fromArray(
				[
					$author$project$Internal$Options$id(domId),
					$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.e8),
					A2(
					$author$project$Internal$Options$when,
					isUnbounded,
					$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.fb)),
					model.bY ? $author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.ey) : $author$project$Internal$Options$nop
				]));
		var baseInteractionHandler = $author$project$Internal$Options$many(
			_List_fromArray(
				[focusHandler, blurHandler]));
		var activateHandler = $author$project$Internal$Options$many(
			A2(
				$elm$core$List$map,
				function (tipe) {
					return A2(
						$author$project$Internal$Options$on,
						tipe,
						A2(
							$elm$json$Json$Decode$map,
							lift,
							$author$project$Internal$Ripple$Implementation$decodeActivate(
								{
									dj: domId,
									dz: function () {
										var _v3 = model.v;
										if (_v3.$ === 1) {
											var activationState = _v3.a;
											return !activationState.bQ;
										} else {
											return false;
										}
									}(),
									bb: isUnbounded,
									dU: function () {
										var _v4 = model.v;
										if (_v4.$ === 1) {
											var activationEvent = _v4.a.am;
											return $elm$core$Maybe$Just(activationEvent);
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}()
								})));
				},
				$author$project$Internal$Ripple$Model$activationEventTypes));
		var _v0 = model.v;
		switch (_v0.$) {
			case 0:
				var interactionHandler = $author$project$Internal$Options$many(
					_List_fromArray(
						[baseInteractionHandler, activateHandler]));
				var cssVars = function () {
					var _v1 = model.cA;
					if (!_v1.$) {
						var clientRect = _v1.a;
						var _v2 = A2($author$project$Internal$Ripple$Implementation$layoutInternal, isUnbounded, clientRect);
						var fgScale = _v2.N;
						var initialSize = _v2.P;
						return A2(
							$author$project$Internal$Ripple$Implementation$cssVariables,
							isUnbounded,
							{N: fgScale, V: clientRect, P: initialSize, aa: '0px', ab: '0px'});
					} else {
						return _List_Nil;
					}
				}();
				var properties = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseProperties,
							$author$project$Internal$Options$many(cssVars),
							A2(
							$author$project$Internal$Options$when,
							_Utils_eq(model.cA, $elm$core$Maybe$Nothing),
							$author$project$Internal$GlobalEvents$onTick(
								A2(
									$elm$json$Json$Decode$map,
									A2(
										$elm$core$Basics$composeL,
										lift,
										$author$project$Internal$Ripple$Model$SetCssVariables(isUnbounded)),
									$author$project$Internal$Ripple$Implementation$decodeClientRect)))
						]));
				return {eS: interactionHandler, e5: properties, c2: noStyle};
			case 1:
				var activatedData = _v0.a;
				var interactionHandler = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseInteractionHandler,
							activateHandler,
							deactivateHandler(activatedData.am)
						]));
				var cssVars = A2(
					$author$project$Internal$Ripple$Implementation$cssVariables,
					isUnbounded,
					{N: activatedData.N, V: activatedData.V, P: activatedData.P, aa: activatedData.aa, ab: activatedData.ab});
				var properties = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseProperties,
							$author$project$Internal$Options$many(cssVars),
							$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.eL),
							A2(
							$author$project$Internal$Options$when,
							isUnbounded,
							A2($author$project$Internal$Options$data, 'mdc-ripple-is-unbounded', '1'))
						]));
				return {eS: interactionHandler, e5: properties, c2: noStyle};
			default:
				var activatedData = _v0.a;
				var interactionHandler = $author$project$Internal$Options$many(
					_List_fromArray(
						[baseInteractionHandler, activateHandler]));
				var cssVars = A2(
					$author$project$Internal$Ripple$Implementation$cssVariables,
					isUnbounded,
					{N: activatedData.N, V: activatedData.V, P: activatedData.P, aa: activatedData.aa, ab: activatedData.ab});
				var properties = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseProperties,
							$author$project$Internal$Options$many(cssVars),
							$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.eM)
						]));
				return {eS: interactionHandler, e5: properties, c2: noStyle};
		}
	});
var $author$project$Internal$Button$Implementation$button = F5(
	function (domId, lift, model, options, nodes) {
		var rippleInterface = A5(
			$author$project$Internal$Ripple$Implementation$view,
			false,
			domId,
			A2($elm$core$Basics$composeL, lift, $author$project$Internal$Button$Model$RippleMsg),
			model._,
			_List_Nil);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Button$Implementation$defaultConfig, options);
		var config = summary.de;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			(!_Utils_eq(config.aJ, $elm$core$Maybe$Nothing)) ? $elm$html$Html$a : $elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-button'),
					$author$project$Internal$Options$cs('mdc-js-button'),
					A2(
					$author$project$Internal$Options$when,
					summary.de._,
					$author$project$Internal$Options$cs('mdc-js-ripple-effect')),
					A2(
					$author$project$Internal$Options$when,
					(!_Utils_eq(config.aJ, $elm$core$Maybe$Nothing)) && (!config.aE),
					$author$project$Internal$Options$attribute(
						$elm$html$Html$Attributes$href(
							A2($elm$core$Maybe$withDefault, '', config.aJ)))),
					A2(
					$author$project$Internal$Options$when,
					config.aE,
					$author$project$Internal$Options$attribute(
						$elm$html$Html$Attributes$disabled(true))),
					A2(
					$author$project$Internal$Options$when,
					config.aE,
					$author$project$Internal$Options$cs('mdc-button--disabled')),
					A3(
					$elm$core$Basics$composeL,
					$author$project$Internal$Options$when(config._),
					$author$project$Internal$Options$many,
					_List_fromArray(
						[rippleInterface.eS, rippleInterface.e5])),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Internal$Options$nop,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Internal$Options$onClick, lift),
							$author$project$Internal$Button$Model$Click(config._)),
						config.b8))
				]),
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						(!config.bC) ? A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (icon_) {
								return _List_fromArray(
									[
										A2(
										$author$project$Internal$Icon$Implementation$view,
										_List_fromArray(
											[
												$author$project$Internal$Options$cs('mdc-button__icon')
											]),
										icon_)
									]);
							},
							config.aI)) : _List_Nil,
						nodes,
						config.bC ? A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (icon_) {
								return _List_fromArray(
									[
										A2(
										$author$project$Internal$Icon$Implementation$view,
										_List_fromArray(
											[
												$author$project$Internal$Options$cs('mdc-button__icon')
											]),
										icon_)
									]);
							},
							config.aI)) : _List_Nil
					])));
	});
var $author$project$Internal$Msg$Dispatch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Options$Lift = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Options$dispatch = function (lift) {
	return $author$project$Internal$Options$Lift(
		$elm$json$Json$Decode$map(
			function (_v0) {
				var message = _v0.dI;
				var stopPropagation = _v0.ed;
				var preventDefault = _v0.dT;
				return {
					dI: lift(
						$author$project$Internal$Msg$Dispatch(message)),
					dT: preventDefault,
					ed: stopPropagation
				};
			}));
};
var $author$project$Internal$Component$render = F3(
	function (get_model, view, ctor) {
		return F4(
			function (lift, idx, store, options) {
				return A3(
					view,
					A2(
						$elm$core$Basics$composeL,
						lift,
						ctor(idx)),
					A2(get_model, idx, store),
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Options$dispatch(lift),
						options));
			});
	});
var $author$project$Internal$Button$Implementation$view = F2(
	function (lift, index) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$Button$Implementation$getSet.a5,
			$author$project$Internal$Button$Implementation$button(index),
			$author$project$Internal$Msg$ButtonMsg,
			lift,
			index);
	});
var $author$project$Material$Button$view = $author$project$Internal$Button$Implementation$view;
var $author$project$Material$Options$when = $author$project$Internal$Options$when;
var $author$project$Internal$Elevation$Implementation$z = function (v) {
	return $author$project$Internal$Options$cs(
		'mdc-elevation--z' + $elm$core$String$fromInt(v));
};
var $author$project$Internal$Elevation$Implementation$z6 = $author$project$Internal$Elevation$Implementation$z(6);
var $author$project$Material$Elevation$z6 = $author$project$Internal$Elevation$Implementation$z6;
var $author$project$UI$Widget$Button$view = F3(
	function (usecase, index, dep) {
		var state = dep.co;
		var vocabulary = dep.bH;
		var button = F3(
			function (id, label, attributes) {
				return A5(
					$author$project$Material$Button$view,
					dep.eX,
					A2($author$project$Index$toString, 'button' + id, index),
					dep.b4,
					A2(
						$elm$core$List$append,
						attributes,
						_List_fromArray(
							[
								$author$project$Material$Typography$button,
								$author$project$Material$Button$ripple,
								$author$project$Material$Options$onClick(
								dep.eY(usecase))
							])),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			});
		var raised = F3(
			function (id, label, attributes) {
				return A3(
					button,
					id,
					label,
					_Utils_ap(
						_List_fromArray(
							[$author$project$Material$Button$raised, $author$project$Material$Elevation$z6]),
						attributes));
			});
		switch (usecase.$) {
			case 3:
				return A3(raised, '1', vocabulary.c1, _List_Nil);
			case 5:
				return A3(button, '2', vocabulary.cK, _List_Nil);
			case 10:
				return A3(
					raised,
					'3',
					vocabulary.cL,
					_List_fromArray(
						[
							A2(
							$author$project$Material$Options$when,
							!$author$project$Selections$areSelected(state.d9),
							A2($author$project$Material$Options$when, state.c6.T.ba, $author$project$Material$Button$disabled))
						]));
			case 12:
				return A3(raised, '4', vocabulary.cL, _List_Nil);
			case 14:
				return A3(
					raised,
					'5',
					vocabulary.cL,
					_List_fromArray(
						[
							A2(
							$author$project$Material$Options$when,
							$elm$core$String$isEmpty(state.bv),
							A2($author$project$Material$Options$when, state.c6.T.ba, $author$project$Material$Button$disabled))
						]));
			case 15:
				return A3(raised, '6', vocabulary.cY, _List_Nil);
			case 16:
				return A3(button, '7', vocabulary.cB, _List_Nil);
			default:
				return A3(raised, '0', 'Undefined button', _List_Nil);
		}
	});
var $author$project$Internal$Typography$Implementation$body1 = $author$project$Internal$Options$cs('mdc-typography--body1');
var $author$project$Material$Typography$body1 = $author$project$Internal$Typography$Implementation$body1;
var $author$project$Internal$Checkbox$Model$Checked = 0;
var $author$project$Internal$Checkbox$Model$Unchecked = 1;
var $author$project$Internal$Checkbox$Implementation$checked = function (value) {
	var state = value ? 0 : 1;
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{
					co: $elm$core$Maybe$Just(state)
				});
		});
};
var $author$project$Material$Checkbox$checked = $author$project$Internal$Checkbox$Implementation$checked;
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Internal$Options$collect1_ = F2(
	function (options, acc) {
		switch (options.$) {
			case 0:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						ao: A2($elm$core$List$cons, x, acc.ao)
					});
			case 1:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						ap: A2($elm$core$List$cons, x, acc.ap)
					});
			case 2:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						an: A2($elm$core$List$cons, x, acc.an)
					});
			case 3:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						au: A2($elm$core$List$cons, x, acc.au)
					});
			case 6:
				var event = options.a;
				var decoder = options.b;
				return _Utils_update(
					acc,
					{
						B: A3($author$project$Internal$Dispatch$add, event, decoder, acc.B)
					});
			case 4:
				var opts = options.a;
				return A3($elm$core$List$foldl, $author$project$Internal$Options$collect1_, acc, opts);
			case 7:
				var lift = options.a;
				return _Utils_update(
					acc,
					{
						B: A2($author$project$Internal$Dispatch$setLift, lift, acc.B)
					});
			case 5:
				return acc;
			default:
				return acc;
		}
	});
var $author$project$Internal$Options$collect_ = A2(
	$elm$core$List$foldl,
	$author$project$Internal$Options$collect1_,
	A6($author$project$Internal$Options$Summary, _List_Nil, _List_Nil, _List_Nil, _List_Nil, $author$project$Internal$Dispatch$defaultConfig, 0));
var $author$project$Internal$Options$styled = F2(
	function (ctor, props) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				$author$project$Internal$Options$collect_(props),
				_List_Nil));
	});
var $author$project$Material$Options$styled = $author$project$Internal$Options$styled;
var $author$project$Internal$Checkbox$Model$AnimationEnd = {$: 3};
var $author$project$Internal$Checkbox$Model$Init = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Internal$Checkbox$Model$NoOp = {$: 0};
var $author$project$Internal$Checkbox$Model$SetFocus = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Dispatch$clear = function (_v0) {
	var config = _v0;
	return _Utils_update(
		config,
		{af: $elm$core$Dict$empty});
};
var $author$project$Internal$Options$applyNativeControl = F3(
	function (summary, ctor, options) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				A2(
					$author$project$Internal$Options$recollect,
					{
						an: _List_Nil,
						ao: _List_Nil,
						de: 0,
						ap: _List_Nil,
						B: $author$project$Internal$Dispatch$clear(summary.B),
						au: _List_Nil
					},
					_Utils_ap(summary.de.dK, options)),
				_List_Nil));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $author$project$Internal$Checkbox$Implementation$defaultConfig = {aE: false, cM: '', dK: _List_Nil, co: $elm$core$Maybe$Nothing};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Internal$Options$onBlur = function (msg) {
	return A2(
		$author$project$Internal$Options$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Internal$Options$onFocus = function (msg) {
	return A2(
		$author$project$Internal$Options$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Internal$Options$onWithOptions = function (evt) {
	return $author$project$Internal$Options$Listener(evt);
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Internal$Checkbox$Implementation$checkbox = F4(
	function (lift, model, options, _v0) {
		var animationClass = function (animation) {
			if (!animation.$) {
				switch (animation.a) {
					case 0:
						var _v2 = animation.a;
						return $author$project$Internal$Options$cs('mdc-checkbox--anim-unchecked-checked');
					case 1:
						var _v3 = animation.a;
						return $author$project$Internal$Options$cs('mdc-checkbox--anim-unchecked-indeterminate');
					case 2:
						var _v4 = animation.a;
						return $author$project$Internal$Options$cs('mdc-checkbox--anim-checked-unchecked');
					case 3:
						var _v5 = animation.a;
						return $author$project$Internal$Options$cs('mdc-checkbox--anim-checked-indeterminate');
					case 4:
						var _v6 = animation.a;
						return $author$project$Internal$Options$cs('mdc-checkbox--anim-indeterminate-checked');
					default:
						var _v7 = animation.a;
						return $author$project$Internal$Options$cs('mdc-checkbox--anim-indeterminate-unchecked');
				}
			} else {
				return $author$project$Internal$Options$nop;
			}
		};
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Checkbox$Implementation$defaultConfig, options);
		var config = summary.de;
		var configState = config.co;
		var currentState = A2($elm$core$Maybe$withDefault, configState, model.b1);
		var stateChangedOrUninitialized = _Utils_eq(model.b1, $elm$core$Maybe$Nothing) || (!_Utils_eq(currentState, configState));
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-checkbox mdc-checkbox--upgraded'),
					A2(
					$author$project$Internal$Options$when,
					_Utils_eq(currentState, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$cs('mdc-checkbox--indeterminate')),
					A2(
					$author$project$Internal$Options$when,
					_Utils_eq(
						currentState,
						$elm$core$Maybe$Just(0)),
					$author$project$Internal$Options$cs('mdc-checkbox--checked')),
					A2(
					$author$project$Internal$Options$when,
					config.aE,
					$author$project$Internal$Options$cs('mdc-checkbox--disabled')),
					animationClass(model.bJ),
					A2(
					$author$project$Internal$Options$when,
					stateChangedOrUninitialized,
					$author$project$Internal$GlobalEvents$onTick(
						$elm$json$Json$Decode$succeed(
							lift(
								A2($author$project$Internal$Checkbox$Model$Init, model.b1, configState))))),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(model.bJ, $elm$core$Maybe$Nothing),
					A2(
						$author$project$Internal$Options$on,
						'animationend',
						$elm$json$Json$Decode$succeed(
							lift($author$project$Internal$Checkbox$Model$AnimationEnd))))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$Internal$Options$applyNativeControl,
					summary,
					$elm$html$Html$input,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-checkbox__native-control'),
							A3(
							$elm$core$Basics$composeL,
							$author$project$Internal$Options$many,
							$elm$core$List$map($author$project$Internal$Options$attribute),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$id(config.cM),
									A2(
									$elm$html$Html$Attributes$property,
									'indeterminate',
									$elm$json$Json$Encode$bool(
										_Utils_eq(currentState, $elm$core$Maybe$Nothing))),
									$elm$html$Html$Attributes$checked(
									_Utils_eq(
										currentState,
										$elm$core$Maybe$Just(0))),
									$elm$html$Html$Attributes$disabled(config.aE)
								])),
							A2(
							$author$project$Internal$Options$onWithOptions,
							'click',
							$elm$json$Json$Decode$succeed(
								{
									dI: lift($author$project$Internal$Checkbox$Model$NoOp),
									dT: true,
									ed: false
								})),
							A2(
							$author$project$Internal$Options$onWithOptions,
							'change',
							$elm$json$Json$Decode$succeed(
								{
									dI: lift($author$project$Internal$Checkbox$Model$NoOp),
									dT: true,
									ed: false
								})),
							$author$project$Internal$Options$onFocus(
							lift(
								$author$project$Internal$Checkbox$Model$SetFocus(true))),
							$author$project$Internal$Options$onBlur(
							lift(
								$author$project$Internal$Checkbox$Model$SetFocus(false)))
						]),
					_List_Nil),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-checkbox__background')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$svg,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('mdc-checkbox__checkmark'),
									$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('mdc-checkbox__checkmark-path'),
											$elm$svg$Svg$Attributes$fill('none'),
											$elm$svg$Svg$Attributes$stroke('white'),
											$elm$svg$Svg$Attributes$d('M1.73,12.91 8.1,19.28 22.79,4.59')
										]),
									_List_Nil)
								])),
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-checkbox__mixedmark')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Internal$Options$internalId = function (id_) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{cM: id_});
		});
};
var $author$project$Internal$Checkbox$Implementation$view = F4(
	function (lift, index, store, options) {
		return A7(
			$author$project$Internal$Component$render,
			$author$project$Internal$Checkbox$Implementation$getSet.a5,
			$author$project$Internal$Checkbox$Implementation$checkbox,
			$author$project$Internal$Msg$CheckboxMsg,
			lift,
			index,
			store,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Options$internalId(index),
				options));
	});
var $author$project$Material$Checkbox$view = $author$project$Internal$Checkbox$Implementation$view;
var $author$project$Internal$FormField$Implementation$view = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-form-field'),
			options));
};
var $author$project$Material$FormField$view = $author$project$Internal$FormField$Implementation$view;
var $author$project$UI$Widget$Checkbox$view = F3(
	function (usecase, index, dep) {
		var checkbox = function (selection) {
			return A2(
				$author$project$Material$FormField$view,
				_List_Nil,
				_List_fromArray(
					[
						A5(
						$author$project$Material$Checkbox$view,
						dep.eX,
						A2($author$project$Index$toString, 'check' + selection.eP, index),
						dep.b4,
						_List_fromArray(
							[
								$author$project$Material$Checkbox$checked(selection.b$),
								$author$project$Material$Options$onClick(
								dep.eY(usecase))
							]),
						_List_Nil),
						A3(
						$author$project$Material$Options$styled,
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Material$Typography$body1,
								$author$project$Material$Options$onClick(
								dep.eY(usecase))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(selection.bB)
							]))
					]));
		};
		if (usecase.$ === 8) {
			var selection = usecase.b;
			return checkbox(selection);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Undefined checkbox')
					]));
		}
	});
var $author$project$Internal$Chip$Implementation$checkmark = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{a_: true});
	});
var $author$project$Material$Chip$checkmark = $author$project$Internal$Chip$Implementation$checkmark;
var $author$project$Material$Options$cs = $author$project$Internal$Options$cs;
var $author$project$Material$Options$css = $author$project$Internal$Options$css;
var $author$project$Internal$Chip$Implementation$decodeKey = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['key']),
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Internal$Chip$Implementation$decodeKeyCode = $elm$html$Html$Events$keyCode;
var $author$project$Internal$Chip$Implementation$onClick = function (msg) {
	var trigger = F2(
		function (key, keyCode) {
			var isEnter = (key === 'Enter') || (keyCode === 13);
			return isEnter ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
		});
	return $author$project$Internal$Options$many(
		_List_fromArray(
			[
				$author$project$Internal$Options$onClick(msg),
				A2(
				$author$project$Internal$Options$on,
				'keyup',
				A2(
					$elm$json$Json$Decode$andThen,
					$elm$core$Basics$identity,
					A3($elm$json$Json$Decode$map2, trigger, $author$project$Internal$Chip$Implementation$decodeKey, $author$project$Internal$Chip$Implementation$decodeKeyCode)))
			]));
};
var $author$project$Material$Chip$onClick = $author$project$Internal$Chip$Implementation$onClick;
var $author$project$Internal$Chip$Implementation$selected = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{bs: true});
	});
var $author$project$Material$Chip$selected = $author$project$Internal$Chip$Implementation$selected;
var $author$project$Internal$Chip$Model$Click = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Chip$Implementation$defaultConfig = {a_: false, b2: $elm$core$Maybe$Nothing, b8: $elm$core$Maybe$Nothing, bs: false, bC: $elm$core$Maybe$Nothing};
var $author$project$Internal$Options$role = function (value) {
	return $author$project$Internal$Options$Attribute(
		A2($elm$html$Html$Attributes$attribute, 'role', value));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Internal$Chip$Implementation$chip = F5(
	function (domId, lift, model, options, nodes) {
		var ripple = A5(
			$author$project$Internal$Ripple$Implementation$view,
			false,
			domId,
			A2($elm$core$Basics$composeL, lift, $author$project$Internal$Chip$Model$RippleMsg),
			model._,
			_List_Nil);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Chip$Implementation$defaultConfig, options);
		var config = summary.de;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-chip'),
					A2(
					$author$project$Internal$Options$when,
					config.bs,
					$author$project$Internal$Options$cs('mdc-chip--selected')),
					$author$project$Internal$Options$cs('mdc-js-ripple-effect'),
					$author$project$Internal$Options$many(
					_List_fromArray(
						[ripple.eS, ripple.e5])),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Internal$Options$nop,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Internal$Options$onClick, lift),
							$author$project$Internal$Chip$Model$Click),
						config.b8)),
					$author$project$Internal$Options$attribute(
					$elm$html$Html$Attributes$tabindex(0))
				]),
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (icon) {
								return _List_fromArray(
									[
										A2(
										$author$project$Internal$Icon$Implementation$view,
										_List_fromArray(
											[
												$author$project$Internal$Options$cs('mdc-chip__icon mdc-chip__icon--leading'),
												A2(
												$author$project$Internal$Options$when,
												config.bs && config.a_,
												$author$project$Internal$Options$cs('mdc-chip__icon--leading-hidden')),
												A2($author$project$Internal$Options$css, 'font-size', '20px')
											]),
										icon)
									]);
							},
							config.b2)),
						_List_fromArray(
						[
							config.a_ ? A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-chip__checkmark')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$svg,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('mdc-chip__checkmark-svg'),
											$elm$svg$Svg$Attributes$viewBox('-2 -3 30 30')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$path,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$class('mdc-chip__checkmark-path'),
													$elm$svg$Svg$Attributes$fill('none'),
													$elm$svg$Svg$Attributes$stroke('black'),
													$elm$svg$Svg$Attributes$d('M1.73,12.91 8.1,19.28 22.79,4.59')
												]),
											_List_Nil)
										]))
								])) : $elm$html$Html$text('')
						]),
						_List_fromArray(
						[
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-chip__text')
								]),
							nodes)
						]),
						A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (icon) {
								return _List_fromArray(
									[
										A2(
										$author$project$Internal$Icon$Implementation$view,
										_List_fromArray(
											[
												$author$project$Internal$Options$cs('mdc-chip__icon mdc-chip__icon--trailing'),
												$author$project$Internal$Options$attribute(
												$elm$html$Html$Attributes$tabindex(0)),
												$author$project$Internal$Options$role('button')
											]),
										icon)
									]);
							},
							config.bC))
					])));
	});
var $author$project$Internal$Chip$Implementation$view = F2(
	function (lift, domId) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$Chip$Implementation$getSet.a5,
			$author$project$Internal$Chip$Implementation$chip(domId),
			$author$project$Internal$Msg$ChipMsg,
			lift,
			domId);
	});
var $author$project$Material$Chip$view = $author$project$Internal$Chip$Implementation$view;
var $author$project$UI$Widget$Chip$view = F3(
	function (usecase, index, dep) {
		var chip = F3(
			function (id, label, attr) {
				return A5(
					$author$project$Material$Chip$view,
					dep.eX,
					A2($author$project$Index$toString, 'chip' + id, index),
					dep.b4,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Material$Chip$onClick(
								dep.eY(usecase))
							]),
						attr),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			});
		var selectable = F2(
			function (selection, attr) {
				return A3(
					chip,
					selection.eP,
					selection.bB,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Material$Chip$checkmark,
								A2($author$project$Material$Options$when, selection.b$, $author$project$Material$Chip$selected),
								$author$project$Material$Options$cs('selectable')
							]),
						attr));
			});
		switch (usecase.$) {
			case 8:
				var selection = usecase.b;
				return A2(
					selectable,
					selection,
					_List_fromArray(
						[
							A2($author$project$Material$Options$css, 'padding', '0.5rem 1rem'),
							A2($author$project$Material$Options$css, 'margin', '0.5rem')
						]));
			case 9:
				var selection = usecase.b;
				return A2(
					selectable,
					selection,
					_List_fromArray(
						[
							A2($author$project$Material$Options$css, 'padding', '0.5rem 1rem'),
							A2($author$project$Material$Options$css, 'margin', '0.5rem')
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Undefined checkbox')
						]));
		}
	});
var $author$project$Internal$Chip$Implementation$chipset = F2(
	function (options, nodes) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Chip$Implementation$defaultConfig, options);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-chip-set')
				]),
			_List_Nil,
			nodes);
	});
var $author$project$Material$Chip$chipset = $author$project$Internal$Chip$Implementation$chipset;
var $author$project$Internal$Chip$Implementation$choice = $author$project$Internal$Options$cs('mdc-chip-set--choice');
var $author$project$Material$Chip$choice = $author$project$Internal$Chip$Implementation$choice;
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$UI$Widget$Options$maxWidth = function (width) {
	return $author$project$Material$Options$many(
		_List_fromArray(
			[
				A2($author$project$Material$Options$css, 'max-width', width),
				A2($author$project$Material$Options$css, 'margin', 'auto')
			]));
};
var $author$project$Internal$LayoutGrid$Implementation$inner = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-layout-grid__inner'),
			options));
};
var $author$project$Internal$LayoutGrid$Implementation$view = function (options) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$author$project$Internal$Options$styled,
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$author$project$Internal$Options$cs('mdc-layout-grid'),
					options)),
			$elm$core$List$singleton),
		$author$project$Internal$LayoutGrid$Implementation$inner(_List_Nil));
};
var $author$project$Material$LayoutGrid$view = $author$project$Internal$LayoutGrid$Implementation$view;
var $author$project$UI$Widget$Layout$view = F4(
	function (kind, children, index, dep) {
		switch (kind) {
			case 0:
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Material$Options$css, 'display', 'flex'),
							A2($author$project$Material$Options$css, 'flex-direction', 'column'),
							A2($author$project$Material$Options$css, 'min-height', '100vh'),
							$author$project$UI$Widget$Options$maxWidth('1000px')
						]),
					children);
			case 1:
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Material$Options$css, 'padding', '1rem')
						]),
					children);
			case 3:
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$footer,
					_List_fromArray(
						[
							A2($author$project$Material$Options$css, 'width', '100%'),
							A2($author$project$Material$Options$css, 'margin-top', 'auto')
						]),
					children);
			case 2:
				return A2($author$project$Material$LayoutGrid$view, _List_Nil, children);
			case 4:
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($author$project$Material$Options$css, 'height', 'auto')
						]),
					children);
			case 5:
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Material$Options$cs('selections')
						]),
					children);
			case 6:
				return A2(
					$author$project$Material$Chip$chipset,
					_List_fromArray(
						[
							$author$project$Material$Chip$choice,
							A2($author$project$Material$Options$css, 'justify-content', 'center'),
							A2($author$project$Material$Options$css, 'align-items', 'center')
						]),
					children);
			default:
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Material$Chip$choice,
							A2($author$project$Material$Options$css, 'justify-content', 'center'),
							A2($author$project$Material$Options$css, 'align-items', 'center')
						]),
					children);
		}
	});
var $author$project$Internal$LinearProgress$Implementation$determinate = function (value) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{cH: true, bG: value});
		});
};
var $author$project$Material$LinearProgress$determinate = $author$project$Internal$LinearProgress$Implementation$determinate;
var $author$project$Domain$Questionnaire$Questions$progressRate = F2(
	function (current, questions) {
		var _v0 = $author$project$Domain$Questionnaire$Questions$volume(questions);
		if (!_v0) {
			return 0;
		} else {
			return current / $author$project$Domain$Questionnaire$Questions$volume(questions);
		}
	});
var $author$project$Domain$Questionnaire$State$Answering$progressRate = function (state) {
	return A2($author$project$Domain$Questionnaire$Questions$progressRate, state.z, state.cf);
};
var $author$project$Internal$LinearProgress$Implementation$defaultConfig = {bK: 0, bL: false, cH: false, a7: false, ci: false, bG: 0};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Internal$LinearProgress$Implementation$view = F2(
	function (options, _v0) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$LinearProgress$Implementation$defaultConfig, options);
		var config = summary.de;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-linear-progress'),
					A2(
					$author$project$Internal$Options$when,
					config.a7,
					$author$project$Internal$Options$cs('mdc-linear-progress--indeterminate')),
					A2(
					$author$project$Internal$Options$when,
					config.ci,
					$author$project$Internal$Options$cs('mdc-linear-progress--reversed'))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__buffering-dots')
						]),
					_List_Nil),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__buffer'),
							A2(
							$author$project$Internal$Options$when,
							config.bL,
							A2(
								$author$project$Internal$Options$css,
								'transform',
								'scaleX(' + ($elm$core$String$fromFloat(config.bK) + ')')))
						]),
					_List_Nil),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__bar mdc-linear-progress__primary-bar'),
							A2(
							$author$project$Internal$Options$when,
							!config.a7,
							A2(
								$author$project$Internal$Options$css,
								'transform',
								'scaleX(' + ($elm$core$String$fromFloat(config.bG) + ')')))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-linear-progress__bar-inner')
								]),
							_List_Nil)
						])),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__bar mdc-linear-progress__secondary-bar')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-linear-progress__bar-inner')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Material$LinearProgress$view = $author$project$Internal$LinearProgress$Implementation$view;
var $author$project$UI$Widget$LinearProgress$view = F3(
	function (usecase, index, dep) {
		var state = dep.co;
		var linearProgress = F2(
			function (attr, value) {
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								A2($author$project$Material$Options$css, 'text-align', 'left')
							]),
						attr),
					_List_fromArray(
						[
							A2(
							$author$project$Material$LinearProgress$view,
							_List_fromArray(
								[
									$author$project$Material$LinearProgress$determinate(value)
								]),
							_List_Nil)
						]));
			});
		if (usecase.$ === 7) {
			return A2(
				linearProgress,
				_List_Nil,
				$author$project$Domain$Questionnaire$State$Answering$progressRate(state.c6));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Undefined linear progress')
					]));
		}
	});
var $author$project$Internal$RadioButton$Implementation$selected = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{bG: true});
	});
var $author$project$Material$RadioButton$selected = $author$project$Internal$RadioButton$Implementation$selected;
var $author$project$Internal$RadioButton$Model$NoOp = {$: 1};
var $author$project$Internal$RadioButton$Model$SetFocus = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$RadioButton$Implementation$defaultConfig = {aE: false, cM: '', dK: _List_Nil, bG: false};
var $author$project$Internal$RadioButton$Implementation$radioButton = F5(
	function (domId, lift, model, options, _v0) {
		var ripple = A5(
			$author$project$Internal$Ripple$Implementation$view,
			true,
			domId + '-div',
			A2($elm$core$Basics$composeL, lift, $author$project$Internal$RadioButton$Model$RippleMsg),
			model._,
			_List_Nil);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$RadioButton$Implementation$defaultConfig, options);
		var config = summary.de;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-radio'),
					$author$project$Internal$Options$many(
					_List_fromArray(
						[ripple.eS, ripple.e5]))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$Internal$Options$applyNativeControl,
					summary,
					$elm$html$Html$input,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-radio__native-control'),
							$author$project$Internal$Options$id(config.cM),
							$author$project$Internal$Options$attribute(
							$elm$html$Html$Attributes$type_('radio')),
							$author$project$Internal$Options$attribute(
							$elm$html$Html$Attributes$checked(config.bG)),
							$author$project$Internal$Options$onFocus(
							lift(
								$author$project$Internal$RadioButton$Model$SetFocus(true))),
							$author$project$Internal$Options$onBlur(
							lift(
								$author$project$Internal$RadioButton$Model$SetFocus(false))),
							A2(
							$author$project$Internal$Options$onWithOptions,
							'click',
							$elm$json$Json$Decode$succeed(
								{
									dI: lift($author$project$Internal$RadioButton$Model$NoOp),
									dT: true,
									ed: false
								})),
							A3(
							$elm$core$Basics$composeL,
							$author$project$Internal$Options$when(config.aE),
							$author$project$Internal$Options$many,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-radio--disabled'),
									$author$project$Internal$Options$attribute(
									$elm$html$Html$Attributes$disabled(true))
								]))
						]),
					_List_Nil),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-radio__background')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-radio__inner-circle')
								]),
							_List_Nil),
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-radio__outer-circle')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Internal$RadioButton$Implementation$view = F4(
	function (lift, domId, store, options) {
		return A7(
			$author$project$Internal$Component$render,
			$author$project$Internal$RadioButton$Implementation$getSet.a5,
			$author$project$Internal$RadioButton$Implementation$radioButton(domId),
			$author$project$Internal$Msg$RadioButtonMsg,
			lift,
			domId,
			store,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Options$internalId(domId),
				options));
	});
var $author$project$Material$RadioButton$view = $author$project$Internal$RadioButton$Implementation$view;
var $author$project$UI$Widget$RadioButton$view = F3(
	function (usecase, index, dep) {
		var radioButton = function (selection) {
			return A3(
				$author$project$Material$Options$styled,
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Material$FormField$view,
						_List_Nil,
						_List_fromArray(
							[
								A5(
								$author$project$Material$RadioButton$view,
								dep.eX,
								A2($author$project$Index$toString, 'radio' + selection.eP, index),
								dep.b4,
								_List_fromArray(
									[
										A2($author$project$Material$Options$when, selection.b$, $author$project$Material$RadioButton$selected),
										$author$project$Material$Options$onClick(
										dep.eY(usecase))
									]),
								_List_Nil),
								A3(
								$author$project$Material$Options$styled,
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Material$Typography$body1,
										$author$project$Material$Options$onClick(
										dep.eY(usecase))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(selection.bB)
									]))
							]))
					]));
		};
		if (usecase.$ === 9) {
			var selection = usecase.b;
			return radioButton(selection);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Undefined radio button')
					]));
		}
	});
var $author$project$Internal$Slider$Implementation$discrete = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{U: true});
	});
var $author$project$Material$Slider$discrete = $author$project$Internal$Slider$Implementation$discrete;
var $author$project$Internal$Slider$Implementation$max = function (value_) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{b3: value_});
		});
};
var $author$project$Material$Slider$max = $author$project$Internal$Slider$Implementation$max;
var $author$project$Internal$Slider$Implementation$min = function (value_) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{b5: value_});
		});
};
var $author$project$Material$Slider$min = $author$project$Internal$Slider$Implementation$min;
var $author$project$Internal$Slider$Implementation$onChange = function (handler) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{
					Y: $elm$core$Maybe$Just(handler)
				});
		});
};
var $author$project$Material$Slider$onChange = $author$project$Internal$Slider$Implementation$onChange;
var $author$project$Internal$Slider$Implementation$step = function (value_) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{cp: value_});
		});
};
var $author$project$Material$Slider$step = $author$project$Internal$Slider$Implementation$step;
var $author$project$Internal$Slider$Implementation$value = function (value_) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{bG: value_});
		});
};
var $author$project$Material$Slider$value = $author$project$Internal$Slider$Implementation$value;
var $author$project$Internal$Slider$Model$Blur = {$: 6};
var $author$project$Internal$Slider$Model$Drag = function (a) {
	return {$: 9, a: a};
};
var $author$project$Internal$Slider$Model$Focus = {$: 5};
var $author$project$Internal$Slider$Model$InteractionStart = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Internal$Slider$Model$KeyDown = {$: 4};
var $author$project$Internal$Slider$Model$NoOp = {$: 0};
var $author$project$Internal$Slider$Model$Resize = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Slider$Model$ThumbContainerPointer = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Internal$Slider$Model$TransitionEnd = {$: 8};
var $author$project$Internal$Slider$Model$Up = {$: 10};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $author$project$Internal$Slider$Implementation$data = F2(
	function (key, decoder) {
		return A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['dataset', key]),
			decoder);
	});
var $author$project$Internal$Slider$Implementation$hasClass = function (_class) {
	return A2(
		$elm$json$Json$Decode$map,
		function (className) {
			return A2($elm$core$String$contains, ' ' + (_class + ' '), ' ' + (className + ' '));
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['className']),
			$elm$json$Json$Decode$string));
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $elm$json$Json$Decode$map6 = _Json_map6;
var $debois$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Internal$Slider$Implementation$decodeGeometry = function () {
	var traverseToContainer = function (decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (doesHaveClass) {
				return doesHaveClass ? decoder : $debois$elm_dom$DOM$parentElement(
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return traverseToContainer(decoder);
						}));
			},
			$author$project$Internal$Slider$Implementation$hasClass('mdc-slider'));
	};
	return $debois$elm_dom$DOM$target(
		traverseToContainer(
			A7(
				$elm$json$Json$Decode$map6,
				F6(
					function (offsetWidth, offsetLeft, decodedDiscrete, decodedMin, decodedMax, decodedStep) {
						return {
							U: decodedDiscrete,
							b3: decodedMax,
							b5: decodedMin,
							bp: {p: offsetLeft, et: offsetWidth},
							cp: decodedStep
						};
					}),
				$debois$elm_dom$DOM$offsetWidth,
				$debois$elm_dom$DOM$offsetLeft,
				$author$project$Internal$Slider$Implementation$hasClass('mdc-slider--discrete'),
				A2(
					$author$project$Internal$Slider$Implementation$data,
					'min',
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toFloat,
							$elm$core$Maybe$withDefault(1)),
						$elm$json$Json$Decode$string)),
				A2(
					$author$project$Internal$Slider$Implementation$data,
					'max',
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toFloat,
							$elm$core$Maybe$withDefault(1)),
						$elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$author$project$Internal$Slider$Implementation$data,
							'step',
							A2($elm$json$Json$Decode$map, $elm$core$String$toFloat, $elm$json$Json$Decode$string)),
							$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
						])))));
}();
var $author$project$Internal$Slider$Implementation$decodePageX = A2(
	$elm$json$Json$Decode$map,
	function (pageX) {
		return {dM: pageX};
	},
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['targetTouches', '0', 'pageX']),
				$elm$json$Json$Decode$float),
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['changedTouches', '0', 'pageX']),
				$elm$json$Json$Decode$float),
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['pageX']),
				$elm$json$Json$Decode$float)
			])));
var $author$project$Internal$Slider$Implementation$defaultConfig = {U: false, b3: 100, b5: 0, Y: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cp: 1, cr: false, bG: 0};
var $author$project$Internal$Slider$Implementation$discretize = F2(
	function (geometry, continuousValue) {
		var steps = function (steps_) {
			return (!steps_) ? 1 : steps_;
		}(
			A2($elm$core$Maybe$withDefault, 1, geometry.cp));
		var continuous = !geometry.U;
		return A3(
			$elm$core$Basics$clamp,
			geometry.b5,
			geometry.b3,
			function () {
				if (continuous) {
					return continuousValue;
				} else {
					var numSteps = $elm$core$Basics$round(continuousValue / steps);
					var quantizedVal = numSteps * steps;
					return quantizedVal;
				}
			}());
	});
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $author$project$Internal$GlobalEvents$onMouseMove = $author$project$Internal$GlobalEvents$listener('globalmousemove');
var $author$project$Internal$GlobalEvents$onPointerMove = $author$project$Internal$GlobalEvents$listener('globalpointermove');
var $author$project$Internal$GlobalEvents$onResize = $author$project$Internal$GlobalEvents$listener('globalresize');
var $author$project$Internal$GlobalEvents$onTouchMove = $author$project$Internal$GlobalEvents$listener('globaltouchmove');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Internal$Slider$Implementation$valueForKey = F4(
	function (key, keyCode, geometry, currentValue) {
		var pageFactor = 4;
		var isRtl = false;
		var isPageUp = _Utils_eq(
			key,
			$elm$core$Maybe$Just('PageUp')) || (keyCode === 33);
		var isPageDown = _Utils_eq(
			key,
			$elm$core$Maybe$Just('PageDown')) || (keyCode === 34);
		var isHome = _Utils_eq(
			key,
			$elm$core$Maybe$Just('Home')) || (keyCode === 36);
		var isEnd = _Utils_eq(
			key,
			$elm$core$Maybe$Just('End')) || (keyCode === 35);
		var isArrowUp = _Utils_eq(
			key,
			$elm$core$Maybe$Just('ArrowUp')) || (keyCode === 38);
		var isArrowRight = _Utils_eq(
			key,
			$elm$core$Maybe$Just('ArrowRight')) || (keyCode === 39);
		var isArrowLeft = _Utils_eq(
			key,
			$elm$core$Maybe$Just('ArrowLeft')) || (keyCode === 37);
		var isArrowDown = _Utils_eq(
			key,
			$elm$core$Maybe$Just('ArrowDown')) || (keyCode === 40);
		var delta = ((isRtl && (isArrowLeft || isArrowRight)) ? $elm$core$Basics$mul(-1) : $elm$core$Basics$identity)(
			geometry.U ? A2($elm$core$Maybe$withDefault, 1, geometry.cp) : ((geometry.b3 - geometry.b5) / 100));
		return A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$clamp, geometry.b5, geometry.b3),
			(isArrowLeft || isArrowDown) ? $elm$core$Maybe$Just(currentValue - delta) : ((isArrowRight || isArrowUp) ? $elm$core$Maybe$Just(currentValue + delta) : (isHome ? $elm$core$Maybe$Just(geometry.b5) : (isEnd ? $elm$core$Maybe$Just(geometry.b3) : (isPageUp ? $elm$core$Maybe$Just(currentValue + (delta * pageFactor)) : (isPageDown ? $elm$core$Maybe$Just(currentValue - (delta * pageFactor)) : $elm$core$Maybe$Nothing))))));
	});
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Internal$Slider$Implementation$slider = F4(
	function (lift, model, options, _v0) {
		var ups = _List_fromArray(
			[$author$project$Internal$GlobalEvents$onMouseUp, $author$project$Internal$GlobalEvents$onPointerUp, $author$project$Internal$GlobalEvents$onTouchEnd]);
		var moves = _List_fromArray(
			[$author$project$Internal$GlobalEvents$onMouseMove, $author$project$Internal$GlobalEvents$onTouchMove, $author$project$Internal$GlobalEvents$onPointerMove]);
		var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.as);
		var downs = _List_fromArray(
			['mousedown', 'pointerdown', 'touchstart']);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Slider$Implementation$defaultConfig, options);
		var config = summary.de;
		var continuousValue = model.K ? A2($elm$core$Maybe$withDefault, config.bG, model.aW) : config.bG;
		var discreteValue = A2($author$project$Internal$Slider$Implementation$discretize, geometry, continuousValue);
		var stepChanged = !_Utils_eq(
			$elm$core$Maybe$Just(config.cp),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.cp;
				},
				model.as));
		var trackScale = (!(config.b3 - config.b5)) ? 0 : ((discreteValue - config.b5) / (config.b3 - config.b5));
		var translateX = function () {
			var v = A3($elm$core$Basics$clamp, config.b5, config.b3, discreteValue);
			var c = (!(!(config.b3 - config.b5))) ? A3($elm$core$Basics$clamp, 0, 1, (v - config.b5) / (config.b3 - config.b5)) : 0;
			return c * geometry.bp.et;
		}();
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-slider'),
					A2(
					$author$project$Internal$Options$when,
					model.bW,
					$author$project$Internal$Options$cs('mdc-slider--focus')),
					A2(
					$author$project$Internal$Options$when,
					model.K,
					$author$project$Internal$Options$cs('mdc-slider--active')),
					A2(
					$author$project$Internal$Options$when,
					_Utils_cmp(discreteValue, config.b5) < 1,
					$author$project$Internal$Options$cs('mdc-slider--off')),
					A2(
					$author$project$Internal$Options$when,
					config.U,
					$author$project$Internal$Options$cs('mdc-slider--discrete')),
					A2(
					$author$project$Internal$Options$when,
					model.a6,
					$author$project$Internal$Options$cs('mdc-slider--in-transit')),
					A2(
					$author$project$Internal$Options$when,
					config.cr,
					$author$project$Internal$Options$cs('mdc-slider--display-markers')),
					$author$project$Internal$Options$attribute(
					$elm$html$Html$Attributes$tabindex(0)),
					A2(
					$author$project$Internal$Options$data,
					'min',
					$elm$core$String$fromFloat(config.b5)),
					A2(
					$author$project$Internal$Options$data,
					'max',
					$elm$core$String$fromFloat(config.b3)),
					A2(
					$author$project$Internal$Options$data,
					'step',
					$elm$core$String$fromFloat(config.cp)),
					$author$project$Internal$Options$role('slider'),
					A2(
					$author$project$Internal$Options$aria,
					'valuemin',
					$elm$core$String$fromFloat(config.b5)),
					A2(
					$author$project$Internal$Options$aria,
					'valuemax',
					$elm$core$String$fromFloat(config.b3)),
					A2(
					$author$project$Internal$Options$aria,
					'valuenow',
					$elm$core$String$fromFloat(discreteValue)),
					A2(
					$author$project$Internal$Options$when,
					_Utils_eq(model.as, $elm$core$Maybe$Nothing) || stepChanged,
					$author$project$Internal$GlobalEvents$onTick(
						A2(
							$elm$json$Json$Decode$map,
							A2($elm$core$Basics$composeL, lift, $author$project$Internal$Slider$Model$Init),
							$author$project$Internal$Slider$Implementation$decodeGeometry))),
					$author$project$Internal$GlobalEvents$onResize(
					A2(
						$elm$json$Json$Decode$map,
						A2($elm$core$Basics$composeL, lift, $author$project$Internal$Slider$Model$Resize),
						$author$project$Internal$Slider$Implementation$decodeGeometry)),
					A2(
					$author$project$Internal$Options$on,
					'keydown',
					A2(
						$elm$json$Json$Decode$map,
						lift,
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (key, keyCode) {
									var activeValue = A4($author$project$Internal$Slider$Implementation$valueForKey, key, keyCode, geometry, config.bG);
									return (!_Utils_eq(activeValue, $elm$core$Maybe$Nothing)) ? $author$project$Internal$Slider$Model$KeyDown : $author$project$Internal$Slider$Model$NoOp;
								}),
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$Just,
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['key']),
											$elm$json$Json$Decode$string)),
										$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
									])),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['keyCode']),
								$elm$json$Json$Decode$int)))),
					A2(
					$author$project$Internal$Options$onWithOptions,
					'keydown',
					A2(
						$elm$json$Json$Decode$map,
						function (message) {
							return {dI: message, dT: true, ed: false};
						},
						A2(
							$elm$json$Json$Decode$map,
							lift,
							A2(
								$elm$json$Json$Decode$andThen,
								$elm$core$Basics$identity,
								A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (key, keyCode) {
											var activeValue = A4($author$project$Internal$Slider$Implementation$valueForKey, key, keyCode, geometry, config.bG);
											return (!_Utils_eq(activeValue, $elm$core$Maybe$Nothing)) ? $elm$json$Json$Decode$succeed($author$project$Internal$Slider$Model$NoOp) : $elm$json$Json$Decode$fail('');
										}),
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Maybe$Just,
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['key']),
													$elm$json$Json$Decode$string)),
												$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
											])),
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['keyCode']),
										$elm$json$Json$Decode$int)))))),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.Y, $elm$core$Maybe$Nothing),
					A2(
						$author$project$Internal$Options$on,
						'keydown',
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (key, keyCode) {
									var activeValue = A2(
										$elm$core$Maybe$map,
										$author$project$Internal$Slider$Implementation$discretize(geometry),
										A4($author$project$Internal$Slider$Implementation$valueForKey, key, keyCode, geometry, config.bG));
									return A2(
										$elm$core$Maybe$withDefault,
										lift($author$project$Internal$Slider$Model$NoOp),
										A3($elm$core$Maybe$map2, $elm$core$Basics$apL, config.Y, activeValue));
								}),
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$Just,
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['key']),
											$elm$json$Json$Decode$string)),
										$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
									])),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['keyCode']),
								$elm$json$Json$Decode$int)))),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.H, $elm$core$Maybe$Nothing),
					A2(
						$author$project$Internal$Options$on,
						'keydown',
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (key, keyCode) {
									var activeValue = A2(
										$elm$core$Maybe$map,
										$author$project$Internal$Slider$Implementation$discretize(geometry),
										A4($author$project$Internal$Slider$Implementation$valueForKey, key, keyCode, geometry, config.bG));
									return A2(
										$elm$core$Maybe$withDefault,
										lift($author$project$Internal$Slider$Model$NoOp),
										A3($elm$core$Maybe$map2, $elm$core$Basics$apL, config.H, activeValue));
								}),
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$Just,
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['key']),
											$elm$json$Json$Decode$string)),
										$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
									])),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['keyCode']),
								$elm$json$Json$Decode$int)))),
					A2(
					$author$project$Internal$Options$on,
					'focus',
					$elm$json$Json$Decode$succeed(
						lift($author$project$Internal$Slider$Model$Focus))),
					A2(
					$author$project$Internal$Options$on,
					'blur',
					$elm$json$Json$Decode$succeed(
						lift($author$project$Internal$Slider$Model$Blur))),
					$author$project$Internal$Options$many(
					A2(
						$elm$core$List$map,
						function (event) {
							return A2(
								$author$project$Internal$Options$on,
								event,
								A2(
									$elm$json$Json$Decode$map,
									A2(
										$elm$core$Basics$composeL,
										lift,
										$author$project$Internal$Slider$Model$InteractionStart(event)),
									$author$project$Internal$Slider$Implementation$decodePageX));
						},
						downs)),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.Y, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$many(
						A2(
							$elm$core$List$map,
							function (event) {
								return A2(
									$author$project$Internal$Options$on,
									event,
									A2(
										$elm$json$Json$Decode$map,
										function (_v1) {
											var pageX = _v1.dM;
											var activeValue = A2(
												$author$project$Internal$Slider$Implementation$discretize,
												geometry,
												A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX));
											return A2(
												$elm$core$Maybe$withDefault,
												lift($author$project$Internal$Slider$Model$NoOp),
												A2(
													$elm$core$Maybe$map,
													function (changeHandler) {
														return changeHandler(activeValue);
													},
													config.Y));
										},
										$author$project$Internal$Slider$Implementation$decodePageX));
							},
							downs))),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.H, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$many(
						A2(
							$elm$core$List$map,
							function (event) {
								return A2(
									$author$project$Internal$Options$on,
									event,
									A2(
										$elm$json$Json$Decode$map,
										function (_v2) {
											var pageX = _v2.dM;
											var activeValue = A2(
												$author$project$Internal$Slider$Implementation$discretize,
												geometry,
												A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX));
											return A2(
												$elm$core$Maybe$withDefault,
												lift($author$project$Internal$Slider$Model$NoOp),
												A2(
													$elm$core$Maybe$map,
													function (inputHandler) {
														return inputHandler(activeValue);
													},
													config.H));
										},
										$author$project$Internal$Slider$Implementation$decodePageX));
							},
							downs))),
					$author$project$Internal$Options$many(
					A2(
						$elm$core$List$map,
						function (handler) {
							return handler(
								$elm$json$Json$Decode$succeed(
									lift($author$project$Internal$Slider$Model$Up)));
						},
						ups)),
					A2(
					$author$project$Internal$Options$when,
					(!_Utils_eq(config.Y, $elm$core$Maybe$Nothing)) && model.K,
					$author$project$Internal$Options$many(
						A2(
							$elm$core$List$map,
							function (handler) {
								return handler(
									A2(
										$elm$json$Json$Decode$map,
										function (_v3) {
											var pageX = _v3.dM;
											var activeValue = A2(
												$author$project$Internal$Slider$Implementation$discretize,
												geometry,
												A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX));
											return A2(
												$elm$core$Maybe$withDefault,
												lift($author$project$Internal$Slider$Model$NoOp),
												A2(
													$elm$core$Maybe$map,
													function (changeHandler) {
														return changeHandler(activeValue);
													},
													config.Y));
										},
										$author$project$Internal$Slider$Implementation$decodePageX));
							},
							ups))),
					A2(
					$author$project$Internal$Options$when,
					(!_Utils_eq(config.H, $elm$core$Maybe$Nothing)) && model.K,
					$author$project$Internal$Options$many(
						A2(
							$elm$core$List$map,
							function (handler) {
								return handler(
									A2(
										$elm$json$Json$Decode$map,
										function (_v4) {
											var pageX = _v4.dM;
											var activeValue = A2(
												$author$project$Internal$Slider$Implementation$discretize,
												geometry,
												A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX));
											return A2(
												$elm$core$Maybe$withDefault,
												lift($author$project$Internal$Slider$Model$NoOp),
												A2(
													$elm$core$Maybe$map,
													function (inputHandler) {
														return inputHandler(activeValue);
													},
													config.H));
										},
										$author$project$Internal$Slider$Implementation$decodePageX));
							},
							ups))),
					A2(
					$author$project$Internal$Options$when,
					model.K,
					$author$project$Internal$Options$many(
						A2(
							$elm$core$List$map,
							function (handler) {
								return handler(
									A2(
										$elm$json$Json$Decode$map,
										A2($elm$core$Basics$composeL, lift, $author$project$Internal$Slider$Model$Drag),
										$author$project$Internal$Slider$Implementation$decodePageX));
							},
							moves))),
					A2(
					$author$project$Internal$Options$when,
					(!_Utils_eq(config.H, $elm$core$Maybe$Nothing)) && model.K,
					$author$project$Internal$Options$many(
						A2(
							$elm$core$List$map,
							function (handler) {
								return handler(
									A2(
										$elm$json$Json$Decode$map,
										function (_v5) {
											var pageX = _v5.dM;
											var activeValue = A2(
												$author$project$Internal$Slider$Implementation$discretize,
												geometry,
												A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX));
											return A2(
												$elm$core$Maybe$withDefault,
												lift($author$project$Internal$Slider$Model$NoOp),
												A2(
													$elm$core$Maybe$map,
													function (inputHandler) {
														return inputHandler(activeValue);
													},
													config.H));
										},
										$author$project$Internal$Slider$Implementation$decodePageX));
							},
							moves)))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-slider__track-container')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A3(
									$author$project$Internal$Options$styled,
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Internal$Options$cs('mdc-slider__track'),
											A2(
											$author$project$Internal$Options$css,
											'transform',
											'scaleX(' + ($elm$core$String$fromFloat(trackScale) + ')'))
										]),
									_List_Nil)
								]),
								config.U ? _List_fromArray(
								[
									A3(
									$author$project$Internal$Options$styled,
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Internal$Options$cs('mdc-slider__track-marker-container')
										]),
									A2(
										$elm$core$List$repeat,
										$elm$core$Basics$round((config.b3 - config.b5) / config.cp),
										A3(
											$author$project$Internal$Options$styled,
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Internal$Options$cs('mdc-slider__track-marker')
												]),
											_List_Nil)))
								]) : _List_Nil
							]))),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-slider__thumb-container'),
							$author$project$Internal$Options$many(
							A2(
								$elm$core$List$map,
								function (event) {
									return A2(
										$author$project$Internal$Options$onWithOptions,
										event,
										A2(
											$elm$json$Json$Decode$map,
											function (message) {
												return {
													dI: lift(message),
													dT: false,
													ed: true
												};
											},
											A2(
												$elm$json$Json$Decode$map,
												$author$project$Internal$Slider$Model$ThumbContainerPointer(event),
												$author$project$Internal$Slider$Implementation$decodePageX)));
								},
								downs)),
							A2(
							$author$project$Internal$Options$on,
							'transitionend',
							$elm$json$Json$Decode$succeed(
								lift($author$project$Internal$Slider$Model$TransitionEnd))),
							A2(
							$author$project$Internal$Options$css,
							'transform',
							'translateX(' + ($elm$core$String$fromFloat(translateX) + 'px) translateX(-50%)'))
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$elm$svg$Svg$svg,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('mdc-slider__thumb'),
											$elm$svg$Svg$Attributes$width('21'),
											$elm$svg$Svg$Attributes$height('21')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$circle,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$cx('10.5'),
													$elm$svg$Svg$Attributes$cy('10.5'),
													$elm$svg$Svg$Attributes$r('7.875')
												]),
											_List_Nil)
										])),
									A3(
									$author$project$Internal$Options$styled,
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Internal$Options$cs('mdc-slider__focus-ring')
										]),
									_List_Nil)
								]),
								config.U ? _List_fromArray(
								[
									A3(
									$author$project$Internal$Options$styled,
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Internal$Options$cs('mdc-slider__pin')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Internal$Options$styled,
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Internal$Options$cs('mdc-slider__pin-value-marker')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromFloat(discreteValue))
												]))
										]))
								]) : _List_Nil
							])))
				]));
	});
var $author$project$Internal$Slider$Implementation$view = A3($author$project$Internal$Component$render, $author$project$Internal$Slider$Implementation$getSet.a5, $author$project$Internal$Slider$Implementation$slider, $author$project$Internal$Msg$SliderMsg);
var $author$project$Material$Slider$view = $author$project$Internal$Slider$Implementation$view;
var $author$project$UI$Widget$Slider$view = F3(
	function (usecase, index, dep) {
		var slider = F4(
			function (id, range, attr1, attr2) {
				return A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					attr1,
					_List_fromArray(
						[
							A5(
							$author$project$Material$Slider$view,
							dep.eX,
							A2($author$project$Index$toString, 'slider' + id, index),
							dep.b4,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Material$Slider$value(range.bG),
										$author$project$Material$Slider$onChange(
										function (n) {
											return dep.eY(
												usecase(
													_Utils_update(
														range,
														{bG: n})));
										}),
										$author$project$Material$Slider$min(
										$elm$core$Basics$floor(range.b5)),
										$author$project$Material$Slider$max(
										$elm$core$Basics$ceiling(range.b3)),
										$author$project$Material$Slider$step(range.cp)
									]),
								attr2),
							_List_Nil)
						]));
			});
		var _v0 = usecase($author$project$Domain$Questionnaire$Range$empty);
		if (_v0.$ === 11) {
			return A4(
				slider,
				'1',
				dep.co.bu,
				_List_fromArray(
					[
						A2($author$project$Material$Options$css, 'padding', '2rem')
					]),
				_List_fromArray(
					[$author$project$Material$Slider$discrete]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Undefined slider')
					]));
		}
	});
var $author$project$UI$Widget$Space$view = F3(
	function (length, index, dep) {
		return A3(
			$author$project$Material$Options$styled,
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Material$Options$css, 'padding', length)
				]),
			_List_Nil);
	});
var $author$project$Internal$TextField$Implementation$label = A2(
	$elm$core$Basics$composeL,
	$author$project$Internal$Options$option,
	F2(
		function (str, config) {
			return _Utils_update(
				config,
				{
					b0: $elm$core$Maybe$Just(str)
				});
		}));
var $author$project$Material$TextField$label = $author$project$Internal$TextField$Implementation$label;
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$Internal$Options$onInput = function (f) {
	return A2(
		$author$project$Internal$Options$on,
		'input',
		A2($elm$json$Json$Decode$map, f, $elm$html$Html$Events$targetValue));
};
var $author$project$Material$Options$onInput = $author$project$Internal$Options$onInput;
var $author$project$Internal$TextField$Implementation$textarea = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{y: true});
	});
var $author$project$Material$TextField$textarea = $author$project$Internal$TextField$Implementation$textarea;
var $author$project$Internal$TextField$Implementation$value = function (value_) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{
					bG: $elm$core$Maybe$Just(value_)
				});
		});
};
var $author$project$Material$TextField$value = $author$project$Internal$TextField$Implementation$value;
var $author$project$Internal$TextField$Model$Blur = {$: 0};
var $author$project$Internal$TextField$Model$Focus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$TextField$Model$Input = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {at: index, eZ: match, e0: number, e9: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Internal$TextField$Model$Geometry = F3(
	function (width, height, labelWidth) {
		return {g: height, dE: labelWidth, et: width};
	});
var $debois$elm_dom$DOM$childNode = function (idx) {
	return $elm$json$Json$Decode$at(
		_List_fromArray(
			[
				'childNodes',
				$elm$core$String$fromInt(idx)
			]));
};
var $author$project$Internal$TextField$Implementation$decodeGeometry = $debois$elm_dom$DOM$target(
	$debois$elm_dom$DOM$parentElement(
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Internal$TextField$Model$Geometry,
			A2($debois$elm_dom$DOM$childNode, 2, $debois$elm_dom$DOM$offsetWidth),
			A2($debois$elm_dom$DOM$childNode, 2, $debois$elm_dom$DOM$offsetHeight),
			A2($debois$elm_dom$DOM$childNode, 1, $debois$elm_dom$DOM$offsetWidth))));
var $author$project$Internal$TextField$Implementation$defaultConfig = {
	a0: $elm$core$Maybe$Nothing,
	dg: $elm$core$Maybe$Nothing,
	aE: false,
	a4: false,
	cM: '',
	b_: false,
	dD: false,
	b0: $elm$core$Maybe$Nothing,
	b2: $elm$core$Maybe$Nothing,
	dK: _List_Nil,
	b9: $elm$core$Maybe$Nothing,
	ca: $elm$core$Maybe$Nothing,
	aN: false,
	aO: $elm$core$Maybe$Nothing,
	bn: $elm$core$Maybe$Nothing,
	ch: false,
	br: $elm$core$Maybe$Nothing,
	y: false,
	bC: $elm$core$Maybe$Nothing,
	fa: $elm$core$Maybe$Just('text'),
	bG: $elm$core$Maybe$Nothing
};
var $author$project$Internal$TextField$Model$defaultGeometry = {g: 0, dE: 0, et: 0};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Internal$Options$for = A2($elm$core$Basics$composeL, $author$project$Internal$Options$Attribute, $elm$html$Html$Attributes$for);
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{eA: false, e$: false},
		string);
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Internal$Options$tabindex = function (value) {
	return $author$project$Internal$Options$Attribute(
		$elm$html$Html$Attributes$tabindex(value));
};
var $author$project$Internal$TextField$Implementation$iconView = F3(
	function (lift, icon, handler) {
		if (!icon.$) {
			var name = icon.a;
			return A3(
				$author$project$Internal$Options$styled,
				$elm$html$Html$i,
				_List_fromArray(
					[
						$author$project$Internal$Options$cs('material-icons mdc-text-field__icon'),
						A2(
						$author$project$Internal$Options$when,
						!_Utils_eq(handler, $elm$core$Maybe$Nothing),
						$author$project$Internal$Options$tabindex(0)),
						A2(
						$author$project$Internal$Options$when,
						!_Utils_eq(handler, $elm$core$Maybe$Nothing),
						$author$project$Internal$Options$role('button')),
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Options$nop,
						A2($elm$core$Maybe$map, $author$project$Internal$Options$onClick, handler))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Internal$TextField$Implementation$textField = F5(
	function (domId, lift, model, options, list) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TextField$Implementation$defaultConfig, options);
		var config = summary.de;
		var focused = model.bY && (!config.aE);
		var isDirty = model.dA || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$neq(''),
				config.bG));
		var htmlLabel = A3(
			$author$project$Internal$Options$styled,
			$elm$html$Html$label,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-floating-label'),
					A2(
					$author$project$Internal$Options$when,
					focused || isDirty,
					$author$project$Internal$Options$cs('mdc-floating-label--float-above')),
					$author$project$Internal$Options$for(config.cM)
				]),
			function () {
				var _v1 = config.b0;
				if (!_v1.$) {
					var str = _v1.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(str)
						]);
				} else {
					return _List_Nil;
				}
			}());
		var isInvalid = config.b_ || function () {
			var _v0 = config.aO;
			if (!_v0.$) {
				var pattern_ = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A3(
						$elm$core$Maybe$map2,
						function (regex) {
							return A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								$elm$regex$Regex$contains(regex));
						},
						$elm$regex$Regex$fromString('^' + (pattern_ + '$')),
						model.bG));
			} else {
				return false;
			}
		}();
		var leadingIcon_ = A3($author$project$Internal$TextField$Implementation$iconView, lift, config.b2, config.b9);
		var trailingIcon_ = A3($author$project$Internal$TextField$Implementation$iconView, lift, config.bC, config.ca);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-text-field'),
					A2(
					$author$project$Internal$Options$when,
					focused,
					$author$project$Internal$Options$cs('mdc-text-field--focused')),
					A2(
					$author$project$Internal$Options$when,
					config.aE,
					$author$project$Internal$Options$cs('mdc-text-field--disabled')),
					A2(
					$author$project$Internal$Options$when,
					config.a4,
					$author$project$Internal$Options$cs('mdc-text-field--fullwidth')),
					A2(
					$author$project$Internal$Options$when,
					isInvalid,
					$author$project$Internal$Options$cs('mdc-text-field--invalid')),
					A2(
					$author$project$Internal$Options$when,
					config.y,
					$author$project$Internal$Options$cs('mdc-text-field--textarea')),
					A2(
					$author$project$Internal$Options$when,
					config.aN && (!config.y),
					$author$project$Internal$Options$cs('mdc-text-field--outlined')),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.b2, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$cs('mdc-text-field--with-leading-icon')),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.bC, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$cs('mdc-text-field--with-trailing-icon'))
				]),
			_List_Nil,
			_Utils_ap(
				list,
				_List_fromArray(
					[
						leadingIcon_,
						A4(
						$author$project$Internal$Options$applyNativeControl,
						summary,
						config.y ? $elm$html$Html$textarea : $elm$html$Html$input,
						_List_fromArray(
							[
								$author$project$Internal$Options$cs('mdc-text-field__input'),
								$author$project$Internal$Options$id(config.cM),
								(config.aN && (!config.y)) ? A2(
								$author$project$Internal$Options$on,
								'focus',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeL, lift, $author$project$Internal$TextField$Model$Focus),
									$author$project$Internal$TextField$Implementation$decodeGeometry)) : A2(
								$author$project$Internal$Options$on,
								'focus',
								$elm$json$Json$Decode$succeed(
									lift(
										$author$project$Internal$TextField$Model$Focus($author$project$Internal$TextField$Model$defaultGeometry)))),
								$author$project$Internal$Options$onBlur(
								lift($author$project$Internal$TextField$Model$Blur)),
								$author$project$Internal$Options$onInput(
								A2($elm$core$Basics$composeL, lift, $author$project$Internal$TextField$Model$Input)),
								A3(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Internal$Options$many,
									$elm$core$List$map($author$project$Internal$Options$attribute)),
								$elm$core$List$filterMap($elm$core$Basics$identity),
								_List_fromArray(
									[
										((!config.y) ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										$elm$html$Html$Attributes$type_(
											A2($elm$core$Maybe$withDefault, 'text', config.fa))),
										(config.aE ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										$elm$html$Html$Attributes$disabled(true)),
										(config.ch ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										A2(
											$elm$html$Html$Attributes$property,
											'required',
											$elm$json$Json$Encode$bool(true))),
										((!_Utils_eq(config.aO, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										A2(
											$elm$html$Html$Attributes$property,
											'pattern',
											$elm$json$Json$Encode$string(
												A2($elm$core$Maybe$withDefault, '', config.aO)))),
										((!_Utils_eq(config.bG, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										$elm$html$Html$Attributes$value(
											A2($elm$core$Maybe$withDefault, '', config.bG)))
									])),
								A2(
								$author$project$Internal$Options$when,
								!_Utils_eq(config.bn, $elm$core$Maybe$Nothing),
								$author$project$Internal$Options$attribute(
									$elm$html$Html$Attributes$placeholder(
										A2($elm$core$Maybe$withDefault, '', config.bn)))),
								A2(
								$author$project$Internal$Options$when,
								config.y && (!_Utils_eq(config.br, $elm$core$Maybe$Nothing)),
								$author$project$Internal$Options$attribute(
									$elm$html$Html$Attributes$rows(
										A2($elm$core$Maybe$withDefault, 0, config.br)))),
								A2(
								$author$project$Internal$Options$when,
								config.y && (!_Utils_eq(config.a0, $elm$core$Maybe$Nothing)),
								$author$project$Internal$Options$attribute(
									$elm$html$Html$Attributes$cols(
										A2($elm$core$Maybe$withDefault, 0, config.a0))))
							]),
						_List_Nil),
						((!config.a4) && ((!config.aN) && (!config.y))) ? htmlLabel : $elm$html$Html$text(''),
						trailingIcon_,
						((!config.aN) && (!config.y)) ? A3(
						$author$project$Internal$Options$styled,
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Internal$Options$cs('mdc-line-ripple'),
								A2(
								$author$project$Internal$Options$when,
								model.bY,
								$author$project$Internal$Options$cs('mdc-line-ripple--active'))
							]),
						_List_Nil) : $elm$html$Html$text(''),
						(config.aN || config.y) ? A3(
						$author$project$Internal$Options$styled,
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Internal$Options$cs('mdc-notched-outline'),
								A2(
								$author$project$Internal$Options$when,
								focused || isDirty,
								$author$project$Internal$Options$cs('mdc-notched-outline--notched'))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Internal$Options$styled,
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Internal$Options$cs('mdc-notched-outline__leading')
									]),
								_List_Nil),
								A3(
								$author$project$Internal$Options$styled,
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Internal$Options$cs('mdc-notched-outline__notch')
									]),
								_List_fromArray(
									[htmlLabel])),
								A3(
								$author$project$Internal$Options$styled,
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Internal$Options$cs('mdc-notched-outline__trailing')
									]),
								_List_Nil)
							])) : $elm$html$Html$text('')
					])));
	});
var $author$project$Internal$TextField$Implementation$view = F4(
	function (lift, domId, store, options) {
		return A7(
			$author$project$Internal$Component$render,
			$author$project$Internal$TextField$Implementation$getSet.a5,
			$author$project$Internal$TextField$Implementation$textField(domId),
			$author$project$Internal$Msg$TextFieldMsg,
			lift,
			domId,
			store,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Options$internalId(domId),
				options));
	});
var $author$project$Material$TextField$view = $author$project$Internal$TextField$Implementation$view;
var $author$project$UI$Widget$TextField$view = F3(
	function (usecase, index, dep) {
		var textField = F3(
			function (id, value, attr) {
				return A5(
					$author$project$Material$TextField$view,
					dep.eX,
					A2($author$project$Index$toString, 'textfield' + id, index),
					dep.b4,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Material$TextField$value(value),
								$author$project$Material$Options$onInput(
								A2($elm$core$Basics$composeL, dep.eY, usecase))
							]),
						attr),
					_List_Nil);
			});
		var _v0 = usecase('');
		if (_v0.$ === 13) {
			return A3(
				textField,
				'1',
				dep.co.bv,
				_List_fromArray(
					[
						$author$project$Material$TextField$textarea,
						$author$project$Material$TextField$label(dep.bH.cI)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Undefined text field')
					]));
		}
	});
var $author$project$Internal$Typography$Implementation$caption = $author$project$Internal$Options$cs('mdc-typography--caption');
var $author$project$Material$Typography$caption = $author$project$Internal$Typography$Implementation$caption;
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $author$project$Internal$Typography$Implementation$headline2 = $author$project$Internal$Options$cs('mdc-typography--headline2');
var $author$project$Material$Typography$headline2 = $author$project$Internal$Typography$Implementation$headline2;
var $author$project$Internal$Typography$Implementation$headline5 = $author$project$Internal$Options$cs('mdc-typography--headline5');
var $author$project$Material$Typography$headline5 = $author$project$Internal$Typography$Implementation$headline5;
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Domain$Questionnaire$State$Answering$progressFraction = function (state) {
	return _Utils_Tuple2(state.z, state.ay);
};
var $author$project$Internal$Typography$Implementation$subtitle1 = $author$project$Internal$Options$cs('mdc-typography--subtitle1');
var $author$project$Material$Typography$subtitle1 = $author$project$Internal$Typography$Implementation$subtitle1;
var $author$project$Internal$Theme$Implementation$textSecondaryOnBackground = $author$project$Internal$Options$cs('mdc-theme--text-secondary-on-background');
var $author$project$Material$Theme$textSecondaryOnBackground = $author$project$Internal$Theme$Implementation$textSecondaryOnBackground;
var $author$project$UI$Widget$Typography$view = F4(
	function (kind, usecase, index, dep) {
		var typography = F4(
			function (html, attr1, attr2, x) {
				return A3(
					$author$project$Material$Options$styled,
					html,
					_Utils_ap(
						_List_Nil,
						_Utils_ap(attr1, attr2)),
					_List_fromArray(
						[
							$elm$html$Html$text(x)
						]));
			});
		var text = function () {
			switch (kind) {
				case 0:
					return A2(
						typography,
						$elm$html$Html$h2,
						_List_fromArray(
							[$author$project$Material$Typography$headline2]));
				case 1:
					return A2(
						typography,
						$elm$html$Html$h5,
						_List_fromArray(
							[$author$project$Material$Typography$headline5]));
				case 2:
					return A2(
						typography,
						$elm$html$Html$h6,
						_List_fromArray(
							[$author$project$Material$Typography$subtitle1]));
				case 3:
					return A2(
						typography,
						$elm$html$Html$p,
						_List_fromArray(
							[$author$project$Material$Typography$body1]));
				default:
					return A2(
						typography,
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Material$Typography$caption]));
			}
		}();
		var _v0 = _Utils_Tuple2(usecase, kind);
		_v0$11:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					switch (_v0.b) {
						case 1:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return A2(text, _List_Nil, dep.bH.eH);
						case 2:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return A2(text, _List_Nil, dep.bH.cW);
						default:
							break _v0$11;
					}
				case 2:
					var _v5 = _v0.a;
					return A2(text, _List_Nil, dep.bH.cF);
				case 3:
					switch (_v0.b) {
						case 1:
							var _v6 = _v0.a;
							var _v7 = _v0.b;
							return A2(text, _List_Nil, dep.aq.cc.bB);
						case 3:
							var _v8 = _v0.a;
							var _v9 = _v0.b;
							return A2(
								text,
								_List_fromArray(
									[
										$author$project$UI$Widget$Options$maxWidth('500px')
									]),
								dep.aq.cc.cn);
						default:
							break _v0$11;
					}
				case 4:
					switch (_v0.b) {
						case 1:
							var _v10 = _v0.a;
							var _v11 = _v0.b;
							return A2(text, _List_Nil, dep.co.c6.T.bB);
						case 3:
							var _v12 = _v0.a;
							var _v13 = _v0.b;
							return A2(
								text,
								_List_fromArray(
									[$author$project$Material$Theme$textSecondaryOnBackground]),
								dep.co.c6.T.bg);
						case 4:
							var _v14 = _v0.a;
							var _v15 = _v0.b;
							return A2(
								text,
								_List_Nil,
								dep.co.c6.T.ba ? dep.bH.cN : '');
						default:
							break _v0$11;
					}
				case 7:
					var _v16 = _v0.a;
					return A2(
						text,
						_List_Nil,
						A2(
							$elm$core$String$join,
							'/',
							A2(
								$elm$core$List$map,
								$elm$core$String$fromInt,
								function (_v17) {
									var a = _v17.a;
									var b = _v17.b;
									return _List_fromArray(
										[a, b]);
								}(
									$author$project$Domain$Questionnaire$State$Answering$progressFraction(dep.co.c6)))));
				case 15:
					var _v18 = _v0.a;
					return A2(text, _List_Nil, dep.aq.cc.bO);
				case 16:
					var _v19 = _v0.a;
					return A2(text, _List_Nil, dep.aq.cc.cq);
				default:
					break _v0$11;
			}
		}
		return A2(text, _List_Nil, 'Undefined typography');
	});
var $author$project$UI$Widget$view = function (widget) {
	switch (widget.$) {
		case 1:
			var kind = widget.a;
			var children = widget.b;
			return F2(
				function (index, dep) {
					return A4(
						$author$project$UI$Widget$Layout$view,
						kind,
						A2(
							$elm$core$List$map,
							function (x) {
								return A3($author$project$UI$Widget$view, x, index, dep);
							},
							children),
						index,
						dep);
				});
		case 0:
			var usecase = widget.a;
			return $author$project$UI$Widget$Button$view(usecase);
		case 3:
			var kind = widget.a;
			var usecase = widget.b;
			return A2($author$project$UI$Widget$Typography$view, kind, usecase);
		case 2:
			var usecase = widget.a;
			return $author$project$UI$Widget$LinearProgress$view(usecase);
		case 4:
			var length = widget.a;
			return $author$project$UI$Widget$Space$view(length);
		case 5:
			var usecase = widget.a;
			return $author$project$UI$Widget$Checkbox$view(usecase);
		case 6:
			var usecase = widget.a;
			return $author$project$UI$Widget$Chip$view(usecase);
		case 7:
			var usecase = widget.a;
			return $author$project$UI$Widget$RadioButton$view(usecase);
		case 8:
			var usecase = widget.a;
			return $author$project$UI$Widget$Slider$view(usecase);
		default:
			var usecase = widget.a;
			return $author$project$UI$Widget$TextField$view(usecase);
	}
};
var $author$project$UI$Page$view = F2(
	function (page, dep) {
		var domainModel = dep.aq;
		var state = dep.co;
		var viewPage = F3(
			function (id, title, widgets) {
				return {
					ez: $elm$core$List$singleton(
						function (widget) {
							return A3(
								$author$project$UI$Widget$view,
								widget,
								$author$project$Index$new(id),
								dep);
						}(
							A2($author$project$UI$Widget$Layout, 0, widgets))),
					bB: title
				};
			});
		switch (page.$) {
			case 0:
				return A3(viewPage, 'p0', 'loading...', _List_Nil);
			case 2:
				return A3(
					viewPage,
					'p404',
					dep.bH.eH,
					_List_fromArray(
						[
							A2(
							$author$project$UI$Widget$Layout,
							1,
							_List_fromArray(
								[
									A2($author$project$UI$Widget$Typography, 1, $author$project$UI$Usecase$PageNotFound),
									A2($author$project$UI$Widget$Typography, 2, $author$project$UI$Usecase$PageNotFound)
								]))
						]));
			default:
				return A3(
					viewPage,
					'p1',
					domainModel.cc.bB,
					function () {
						if (state.eU) {
							return _List_fromArray(
								[
									A2(
									$author$project$UI$Widget$Layout,
									1,
									_List_fromArray(
										[
											$author$project$UI$Widget$Space('3rem'),
											A2($author$project$UI$Widget$Typography, 2, $author$project$UI$Usecase$ClosePaper)
										])),
									A2(
									$author$project$UI$Widget$Layout,
									3,
									_List_fromArray(
										[
											A2($author$project$UI$Widget$Typography, 4, $author$project$UI$Usecase$CheckProvider),
											$author$project$UI$Widget$Space('1rem')
										]))
								]);
						} else {
							var _v1 = state.c6.Z;
							switch (_v1) {
								case 0:
									return _List_fromArray(
										[
											A2(
											$author$project$UI$Widget$Layout,
											1,
											_List_fromArray(
												[
													$author$project$UI$Widget$Space('1rem'),
													A2($author$project$UI$Widget$Typography, 1, $author$project$UI$Usecase$StartAnswer),
													A2($author$project$UI$Widget$Typography, 3, $author$project$UI$Usecase$StartAnswer),
													$author$project$UI$Widget$Space('2rem'),
													$author$project$UI$Widget$Button($author$project$UI$Usecase$StartAnswer)
												])),
											A2(
											$author$project$UI$Widget$Layout,
											3,
											_List_fromArray(
												[
													$author$project$UI$Widget$Space('0.5rem'),
													A2($author$project$UI$Widget$Typography, 4, $author$project$UI$Usecase$CheckProvider),
													$author$project$UI$Widget$Space('1rem')
												]))
										]);
								case 1:
									return _List_fromArray(
										[
											A2(
											$author$project$UI$Widget$Layout,
											1,
											_List_fromArray(
												[
													$author$project$UI$Widget$Space('1rem'),
													A2($author$project$UI$Widget$Typography, 1, $author$project$UI$Usecase$CheckQuestion),
													A2($author$project$UI$Widget$Typography, 3, $author$project$UI$Usecase$CheckQuestion),
													$author$project$UI$Page$answerForm(dep)
												])),
											A2(
											$author$project$UI$Widget$Layout,
											3,
											_List_fromArray(
												[
													$author$project$UI$Widget$Space('1rem'),
													$author$project$UI$Widget$Button($author$project$UI$Usecase$GoBack),
													$author$project$UI$Widget$Space('0.5rem'),
													$author$project$UI$Widget$LinearProgress($author$project$UI$Usecase$CheckProgress),
													A2($author$project$UI$Widget$Typography, 4, $author$project$UI$Usecase$CheckProgress),
													$author$project$UI$Widget$Space('0.5rem'),
													A2($author$project$UI$Widget$Typography, 4, $author$project$UI$Usecase$CheckProvider),
													$author$project$UI$Widget$Space('1rem')
												]))
										]);
								default:
									return _List_fromArray(
										[
											A2(
											$author$project$UI$Widget$Layout,
											1,
											_List_fromArray(
												[
													$author$project$UI$Widget$Space('3rem'),
													A2($author$project$UI$Widget$Typography, 1, $author$project$UI$Usecase$SendAnswer),
													$author$project$UI$Widget$Space('2rem'),
													$author$project$UI$Widget$Button($author$project$UI$Usecase$SendAnswer)
												])),
											A2(
											$author$project$UI$Widget$Layout,
											3,
											_List_fromArray(
												[
													$author$project$UI$Widget$Space('1rem'),
													$author$project$UI$Widget$Button($author$project$UI$Usecase$GoBack),
													$author$project$UI$Widget$Space('0.5rem'),
													$author$project$UI$Widget$LinearProgress($author$project$UI$Usecase$CheckProgress),
													A2($author$project$UI$Widget$Typography, 4, $author$project$UI$Usecase$CheckProgress),
													$author$project$UI$Widget$Space('0.5rem'),
													A2($author$project$UI$Widget$Typography, 4, $author$project$UI$Usecase$CheckProvider),
													$author$project$UI$Widget$Space('1rem')
												]))
										]);
							}
						}
					}());
		}
	});
var $author$project$Main$view = function (model) {
	return A2(
		$author$project$UI$Page$view,
		model.ai,
		{aq: model.aq, eX: $author$project$Main$Mdc, eY: $author$project$Main$Usecase, b4: model.b4, co: model.co, al: model.al, bH: model.bH});
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{O: $author$project$Main$init, e1: $author$project$Main$UrlChanged, e2: $author$project$Main$UrlRequest, R: $author$project$Main$subscriptions, cs: $author$project$Main$update, cu: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	$elm$json$Json$Decode$succeed(0))(0)}});}(this));